import _defineProperty from "babel-runtime/helpers/defineProperty";

var _headers, _headers2;

/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

/* eslint-disable no-var */
/**
 * Account page methods
 * -----------------------------------------------------------------------------
 *
 * @namespace rechargeMethods
 */

import axios from 'axios';
import moment from 'moment';
import Flickity from 'flickity';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';

var rechargeCommonAPI = axios.create({
  baseURL: 'https://scripts.doggielawn.com/recharge/doggielawn/api/common',
  headers: (_headers = {
    Accept: 'application/json, text/javascript, /; q=0.01',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Cache-Control': 'must-revalidate'
  }, _defineProperty(_headers, "Cache-Control", 'no-cache'), _defineProperty(_headers, "Cache-Control", 'no-store'), _defineProperty(_headers, "Pragma", 'no-cache'), _defineProperty(_headers, "crossDomain", true), _headers)
});

var rechargeSUbAPI = axios.create({
  baseURL: 'https://scripts.doggielawn.com/recharge/doggielawn/api/subscription',
  headers: (_headers2 = {
    Accept: 'application/json, text/javascript, /; q=0.01',
    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
    'Cache-Control': 'must-revalidate'
  }, _defineProperty(_headers2, "Cache-Control", 'no-cache'), _defineProperty(_headers2, "Cache-Control", 'no-store'), _defineProperty(_headers2, "Pragma", 'no-cache'), _defineProperty(_headers2, "crossDomain", true), _headers2)
});

var rechargeMethods = {
  data: function data() {
    return {
      shipAddMismatch: false,
      shipAddMismatchWarning: false,
      upgradePlan: false,
      hasRechargePopup: false,
      hasdefaultBox: true,
      hasRechargeAddonsPopup: false,
      hasSubscription: false,
      hasUpdateBox: false,
      hasTray: false,
      hasUpdateBoxState: false,
      hasUpdateBoxGrass: false,
      hasUpdateBoxFreq: false,
      hasUpdateBoxCheck: false,
      hasUpdateBoxGrassButton: false,
      hasUpdateBoxCompare: false,
      hasUpdateBoxCompareButton: false,
      hasUpdateBoxQty: false,
      hasUpdateButton: false,
      hasAddonsButton: false,
      hasUpgradeBox: false,
      hasAddonsConfirm: false,
      hasSkipShipment: false,
      hasSkipBox: false,
      hasSkipButton: false,
      hasManageAddons: false,
      hasCancelBox: false,
      hasCancelBox1: false,
      hasCancelBox2: false,
      hasCancelBox3: false,
      hasCancelCOVID50: false,
      hasCancelBox4: false,
      hasCancelBox5: false,
      hasCancelBox6: false,
      hasCancelBoxshipping: false,
      isAddonsUpdate: false,
      hasCancelBoxCovid: false,
      checkedBox: false,
      hasCancelBoxFinal: false,
      cancel_confirm: false,
      hasCancelBoxDig: false,
      hasSkipBoxWithCancel: false,
      hasCancelBtn: false,
      hasAddressBox: false,
      hasBillingAddressBox: false,
      hasBillingInfo: false,
      hasUpdateAddress: false,
      hasUpdateBillingAddress: false,
      hasAnyEvent: false,
      shipping_mail: false,
      hasaddonsEvent: false,
      shopifyDate: window.theme.shopify_date,
      hasEnableSkipBox: false,
      hasOfferAdded: false,
      changeFreqAddon: false,
      newAddonFreq: false,
      hasCancelshipping: false,
      shippingReason: '',
      hasSkipBoxText: 'You have already skipped your next Mission, wanting to un-skip? Please email us at <a href="mailto:questions@battlbox.com">questions@battlbox.com</a>.',
      rechargeData: {
        customerHash: '',
        rechargecustomerID: '',
        cardDetails: [],
        addonsOrders: '',
        subscriptionsList: [],
        recurringAddons: [],
        currentSubscription: [],
        nextChargeFormats: null,
        nextChargeFormatsDisplay: null,
        pauseDate: '',
        CancelReason: '',
        productJson: '',
        newTitle: '',
        snoozeSkipDate: '',
        buttonSkipText: '',
        variant_title_name: '',
        packageProduct: '',
        selectedVariant: {},
        selectedpackageVariant: {},
        product_title_name: '',
        address: {},
        charge_id: '',
        hasSubscriptionVariants: [],
        hasSubscriptionpackageVariants: [],
        hasProductSelected: {},
        hasPackageProductSelected: {},
        skipDateResponse: {},
        billingDetail: {},
        updateQty: ''
      },
      updateProduct: {
        selectedStage: '',
        selectedState: '',
        selectedGrass: '',
        selectedFreq: ''
      },
      customFrequency: {
        currentNextChargeDate: '',
        currentFrequency: '',
        processDate: ''
      },
      enableQTY: false
    };
  },


  methods: {
    _initRecharge: function _initRecharge() {
      setTimeout(function () {
        $('.table-wrapper table').footable({
          breakpoints: {
            phone: 581,
            halfTab: 767,
            tablet: 1024
          }
        });
      }, 100);
      if (app.currentTemplate !== 'account') {
        return;
      }
      if (app.customer.email != '') {
        app._customerHashID(app.customer.email);
      }
      if (app.customer.id != '') {
        app._getSubscriptions(app.customer.id);
      }
      if (app.customer.tags != null) {
        var OfferAdded = app.customer.tags.filter(function (tag) {
          return tag === "Offer_used";
        });
        if (OfferAdded.length > 0) {
          app.hasOfferAdded = true;
        }
      }

      $('[subscription-billing-modal]').on('click', function () {
        $('#subscription-billing').modal('show');
      });
    },
    _openCardDetails: function _openCardDetails() {
      app.isOverlayVisible = false;
      app._unlockScroll();
      app.hasBillingAddressBox = false;
      app.hasRechargePopup = false;
      $('#subscription-billing').modal('show');
    },
    _customerHashID: function _customerHashID(email) {
      var config = {
        data: {
          url: "/customers?email=" + email,
          method: 'GET'
        }
      };
      // eslint-disable-next-line promise/catch-or-return
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.customers[0] !== undefined) {
          app.rechargeData.customerHash = response.data.data.customers[0].hash;
          app.rechargeData.rechargecustomerID = response.data.data.customers[0].id;
          app.rechargeData.billingDetail = response.data.data.customers[0];
          app._getAddonsOrders();
          app._initCardDetails();
        }
      });
    },
    _initCardDetails: function _initCardDetails() {
      var config = {
        data: {
          url: "/customers/" + app.rechargeData.rechargecustomerID + "/payment_sources",
          method: 'GET',
          data: []
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // eslint-disable-next-line promise/always-return
        app.rechargeData.cardDetails = response.data.data.payment_sources[0];
        $('[data-card-details]').show();
      });
    },
    _footableJs: function _footableJs() {
      $('.footable').footable({
        breakpoints: {
          phone: 581,
          halfTab: 767,
          tablet: 1024
        }
      });
    },
    _pointCheck: function _pointCheck() {
      setTimeout(function () {
        $('[data-recharge-price] [data-point-add]').each(function () {
          var val = $(this).text();
          if (val.indexOf('.') === -1) {
            var valPut = val + ".00";
            $(this).text(valPut);
          }
        });
      }, 300);
    },
    _getCurrentTarget: function _getCurrentTarget(event, popupTarget) {
      switch (popupTarget) {
        case 'change-box':
          app.hasUpdateBox = true;
          app.hasTray = true;
          setTimeout(function () {
            $("#product_" + app.rechargeData.currentSubscription.shopify_product_id).closest('.product_list').addClass('active');
            $("#product_" + app.rechargeData.currentSubscription.shopify_product_id).prop('checked', true);
            var current_size = app.rechargeData.currentSubscription.product_title;
            if (app.rechargeData.currentSubscription.product_title == "DoggieLawn") {
              current_size = app.rechargeData.currentSubscription.variant_title;
            } else if (app.rechargeData.currentSubscription.product_title.indexOf('Bark Potty') > -1) {
              app._updateSubscription(app.rechargeData.productJson);
              current_size = app.rechargeData.hasProductSelected.handle;
              $("#" + current_size).closest('.subscription-details').find('input').prop('checked', true);
            }
            if (app.rechargeData.currentSubscription.product_title.indexOf('Disposable DoggieLawn') > -1) {
              $('[data-plan="XL DoggieLawn"]').removeClass('d-flex').addClass('d-none');
            } else {
              $('[data-plan="XL DoggieLawn"]').removeClass('d-none').addClass('d-flex');
            }
            if (current_size.indexOf('Standard') > -1) {
              $('#standard-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
            } else if (current_size.indexOf('Medium') > -1) {
              $('#medium-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
            } else if (current_size.indexOf('Large') > -1) {
              $('#large-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
            } else if (current_size.indexOf('XL') > -1) {
              $('#xl-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
              app.hasUpdateButton = true;
            }
          }, 300);
          break;
        case 'change-delivery-box':
          app.hasUpdateBoxFreq = true;
          app.hasUpdateBoxCheck = true;
          app.checkedBox = true;
          app.hasTray = false;
          console.log('1');
          app._updateSubscription(app.rechargeData.productJson);
          break;
        case 'skip-shipment-box':
          app.hasSkipBox = true;
          // eslint-disable-next-line no-case-declarations
          var nextChargeDate = moment(app.rechargeData.currentSubscription.next_charge_scheduled_at).add(app.rechargeData.currentSubscription.charge_interval_frequency, 'week').format('MMMM D, YYYY');
          // eslint-disable-next-line no-case-declarations
          var SimplenextChargeDate = moment(app.rechargeData.currentSubscription.next_charge_scheduled_at).add(app.rechargeData.currentSubscription.charge_interval_frequency, 'week').format('Y-MM-DD');
          app.rechargeData.nextChargeFormats = nextChargeDate;
          app.rechargeData.skipDateResponse.skip_next_charge_date = SimplenextChargeDate + "T00:00:00";
          // eslint-disable-next-line no-case-declarations
          var nextChargeFormatsDisplay = moment(SimplenextChargeDate).format('dddd, MMMM D, YYYY');
          app.rechargeData.nextChargeFormatsDisplay = nextChargeFormatsDisplay;
          app._get_pastOrder();
          break;
        case 'edit-shipping-box':
          app.hasAddressBox = true;
          app.shipAddMismatchWarning = false;
          setTimeout(function () {
            $("#AddressProvinceNew option[data-state=\"" + app.rechargeData.address.province.toLowerCase().split(' ').join('-') + "\"]").prop('selected', true);
            $("#AddressCountryNew option[value=\"" + app.rechargeData.address.country + "\"]").prop('selected', true);
            $('[data-first-name]').val(app.rechargeData.address.first_name);
            $('[data-last-name]').val(app.rechargeData.address.last_name);
            $('[data-address1]').val(app.rechargeData.address.address1);
            $('[data-address2]').val(app.rechargeData.address.address2);
            $('[data-city]').val(app.rechargeData.address.city);
            $('[data-zip]').val(app.rechargeData.address.zip);
            $('[data-company]').val(app.rechargeData.address.company);
            $('[data-phone]').val(app.rechargeData.address.phone);
          }, 300);
          app._getChangeShippingAddress();
          break;
        case 'edit-billing-box':
          app.hasBillingInfo = true;
          break;
        case 'edit-billing-add-box':
          app.hasBillingAddressBox = true;
          setTimeout(function () {
            new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
              hideElement: 'AddressProvinceContainerNew'
            });
            $("#AddressProvinceNew option[value=\"" + app.rechargeData.billingDetail.billing_province + "\"]").prop('selected', true);
            $("#AddressCountryNew option[value=\"" + app.rechargeData.billingDetail.billing_country + "\"]").prop('selected', true);
            $('[data-billing-first-name]').val(app.rechargeData.billingDetail.first_name);
            $('[data-billing-last-name]').val(app.rechargeData.billingDetail.last_name);
            $('[data-billing-address1]').val(app.rechargeData.billingDetail.billing_address1);
            $('[data-billing-address2]').val(app.rechargeData.billingDetail.billing_address2);
            $('[data-billing-city]').val(app.rechargeData.billingDetail.billing_city);
            $('[data-billing-zip]').val(app.rechargeData.billingDetail.billing_zip);
            $('[data-billing-company]').val(app.rechargeData.billingDetail.billing_company);
            $('[data-billing-phone]').val(app.rechargeData.billingDetail.billing_phone);
          }, 300);
          app._getChangeBillingAddress();
          break;
        case 'cancel-subscription-box':
          app.hasCancelBox = true;
          break;
        case 'cancel-it':
          app.hasCancelBox3 = true;
          setTimeout(function () {
            // eslint-disable-next-line no-case-declarations
            var date = app.rechargeData.currentSubscription.next_charge_scheduled_at.split('T')[0];
            $('[data-pause-date-skip]').flatpickr({
              minDate: 'today',
              altInput: true,
              altFormat: 'F j, Y',
              onChange: function onChange(val) {
                $('[data-text-show], [data-button-show]').removeClass('d-none');
                var dateSkip = moment(val[0]).format('MMMM D, YYYY');
                app.rechargeData.snoozeSkipDate = dateSkip;
                app.rechargeData.buttonSkipText = "Snooze my next subscription process date until " + dateSkip;
              },

              disable: [
                //  function(date) {
                //    return date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 5 || date.getDay() === 6; // disable weekends
                //  },
              ]
            });
          }, 300);
          break;
        case 'cancel-with-comment':
          app.hasCancelBox5 = true;
          break;
        case 'cancel-confirmation-box':
          app.cancel_confirm = true;
          break;
        case 'cancel-with-covid':
          app.hasCancelBoxCovid = true;
          break;
        case 'cancel-covid-50':
          app.hasCancelBox3 = true;
          app.hasCancelCOVID50 = true;
          setTimeout(function () {
            // eslint-disable-next-line no-case-declarations
            var date = app.rechargeData.currentSubscription.next_charge_scheduled_at.split('T')[0];
            $('[data-pause-date-skip]').flatpickr({
              minDate: 'today',
              altInput: true,
              altFormat: 'F j, Y',
              onChange: function onChange(val) {
                $('[data-text-show], [data-button-show]').removeClass('d-none');
                var dateSkip = moment(val[0]).format('MMMM D, YYYY');
                app.rechargeData.snoozeSkipDate = dateSkip;
                app.rechargeData.buttonSkipText = "Snooze my next subscription process date until " + dateSkip;
              },

              disable: [
                //  function(date) {
                //    return date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 5 || date.getDay() === 6; // disable weekends
                //  },
              ]
            });
          }, 300);
          break;
        case 'change-freq-cancel':
          app._gobackPopup(event);
          app._getCurrentTarget(event, 'change-delivery-box');
          break;
        case 'manage-addons':
          app.hasManageAddons = true;
          setTimeout(function () {

            app._footableJs();
          }, 50);

      }
      app.hasdefaultBox = false;
      app._focusToPopup();
      window.addEventListener('keydown', function (e) {
        app._handleKey(e);
      });
    },
    _closeDrawer: function _closeDrawer(event) {
      $('body').removeClass('popup-sub-open');
      app.isOverlayVisible = false;
      window.removeEventListener('keydown', function (e) {
        app._handleKey(e);
      });
      $('[data-manage-subscription]').trigger('focus');
      app._unlockScroll();
      app.rechargeData.productJson = '';
      app.rechargeData.buttonSkipText = '';
      app.rechargeData.product_title_name = '';
      app.hasSkipShipment = false;
      app.hasAddonsConfirm = false;
      app.isSelectOfferFrom = '';
      app.hasSkipFromCancel = false;
      app.hasRechargePopup = false;
      app.hasRechargeAddonsPopup = false;
      app.checkedBox = false;
      app.rechargeData.currentSubscription = [];
      app.rechargeData.nextChargeFormats = null;
      app.rechargeData.hasSubscriptionVariants = [];
      app.rechargeData.hasSubscriptionpackageVariants = [];
      app.updateProduct.selectedGrass = '';
      app.rechargeData.currentSubscription.skipType = '';
      app.hasCancelBox = false;
      app.hasCancelBox1 = false;
      app.hasCancelBox2 = false;
      app.hasCancelBox3 = false;
      app.hasCancelBox4 = false;
      app.hasCancelBox5 = false;
      app.hasCancelBoxshipping = false;
      app.hasCancelshipping = false;
      app.hasCancelBoxCovid = false;
      app.hasCancelCOVID50 = false;
      app.hasCancelBoxFinal = false;
      app.cancel_confirm = false;
      app.hasCancelBoxDig = false;
      app.hasSkipBoxWithCancel = false;
      app.hasAddressBox = false;
      app.hasBillingAddressBox = false;
      app.hasSkipBox = false;
      app.hasManageAddons = false;
      app.changeFreqAddon = false;
      app.newAddonFreq = false;
      app.hasSkipButton = false;
      app.hasUpdateBox = false;
      app.hasBillingInfo = false;
      app.hasUpdateBoxState = false, app.hasUpdateBoxGrass = false, app.hasUpdateBoxGrassButton = false, app.hasUpdateBoxFreq = false, app.hasUpdateBoxCheck = false, app.hasUpdateBoxCompare = false, app.hasUpdateBoxCompareButton = false, app.hasUpdateButton = false;
      app.hasCancelBtn = false;
      app.hasUpgradeBox = false;
      app.hasEnableSkipBox = false;
      app.hasUpdateAddress = false;
      app.hasUpdateBillingAddress = false;
      app.hasAnyEvent = false;
      app.shipping_mail = false;
      app.enableQTY = false;
      app.hasUpdateBoxQty = false;
      $('[data-grass-central]').removeClass('d-none').addClass('d-flex');
      $('[data-grass-eastern]').removeClass('d-none').addClass('d-flex');
      $('[data-grass-original-group-2]').removeClass('d-none').addClass('d-flex');
      $('[data-grass-original-group-3]').removeClass('d-none').addClass('d-flex');
      $('[data-grass]').addClass('d-none');
      $('[data-freq-show]').addClass('d-none');
      $('input').prop('checked', false);
      $('select').val('');
    },
    _gobackPopup: function _gobackPopup(event) {
      app.hasdefaultBox = true;
      app.hasSkipShipment = false;
      app.isSelectOfferFrom = '';
      app.hasSkipFromCancel = false;
      app.rechargeData.hasSubscriptionVariants = [];
      app.rechargeData.hasSubscriptionpackageVariants = [];
      app.rechargeData.buttonSkipText = '';
      app.updateProduct.selectedGrass = '';
      app.rechargeData.currentSubscription.skipType = '';
      app.hasCancelBox = false;
      app.hasCancelBox1 = false;
      app.hasCancelBox2 = false;
      app.hasCancelBox3 = false;
      app.hasCancelBox6 = false;
      app.hasCancelshipping = false;
      app.hasCancelBox4 = false;
      app.hasCancelBox5 = false;
      app.hasCancelBoxshipping = false;
      app.hasCancelBoxCovid = false;
      app.hasCancelBoxFinal = false;
      app.cancel_confirm = false;
      app.hasCancelCOVID50 = false;
      app.hasCancelBoxDig = false;
      app.hasSkipBoxWithCancel = false;
      app.hasAddressBox = false;
      app.hasBillingAddressBox = false;
      app.hasSkipBox = false;
      app.hasManageAddons = false;
      app.changeFreqAddon = false;
      app.newAddonFreq = false;
      app.checkedBox = false;
      app.hasSkipButton = false;
      app.hasUpdateBox = false;
      app.hasUpdateBoxState = false, app.hasUpdateBoxGrass = false, app.hasUpdateBoxGrassButton = false, app.hasUpdateBoxFreq = false, app.hasUpdateBoxCheck = false, app.hasUpdateBoxCompare = false, app.hasUpdateBoxCompareButton = false, app.hasUpdateButton = false;
      app.hasBillingInfo = false;
      app.hasCancelBtn = false;
      app.hasUpgradeBox = false;
      app.hasEnableSkipBox = false;
      app.hasUpdateAddress = false;
      app.hasUpdateBillingAddress = false;
      app.hasAnyEvent = false;
      app.shipping_mail = false;
      app.enableQTY = false;
      app.hasUpdateBoxQty = false;
      app.rechargeData.currentSubscription.match_name = app.rechargeData.currentSubscription.product_title;
      setTimeout(function () {
        $('[data-grass-central]').removeClass('d-none').addClass('d-flex');
        $('[data-grass-eastern]').removeClass('d-none').addClass('d-flex');
        $('[data-grass-original-group-2]').removeClass('d-none').addClass('d-flex');
        $('[data-grass-original-group-3]').removeClass('d-none').addClass('d-flex');
      }, 1000);

      $('[data-grass]').addClass('d-none');
      $('[data-freq-show]').addClass('d-none');
      $('input').prop('checked', false);
      $('select').val('');
      app._focusToPopup();
    },
    _gobackAddonsPopup: function _gobackAddonsPopup(event) {
      app.hasAddonsButton = false;
      $('.addons-collections').removeClass('d-none');
      $('.addons-product').addClass('d-none');
      $('.addons-collections input').each(function () {
        $(this).prop('checked', false);
      });
    },
    _toggleRechargeDrawer: function _toggleRechargeDrawer(event, index) {

      $('body').addClass('popup-sub-open');
      app.hasdefaultBox = true;
      app.rechargeData.currentSubscription = app.rechargeData.subscriptionsList[index];
      app._displayDiscount();
      app.rechargeData.updateQty = app.rechargeData.currentSubscription.quantity;
      app._reasonHide();
      app._getAddons();
      // app._getChargeId(app.rechargeData.currentSubscription.id);

      if (app.rechargeData.currentSubscription.product_title.indexOf('Standard') > -1) {
        app.rechargeData.productJson = 'standard';
        if (app.rechargeData.currentSubscription.product_title.indexOf('Disposable DoggieLawn') > -1) {
          app.rechargeData.product_title_name = 'Standard Disposable DoggieLawn';
          app.rechargeData.currentSubscription.match_name = app.rechargeData.productJson;
        } else {
          app.rechargeData.product_title_name = 'Standard Doggielawn';
        }
        setTimeout(function () {
          $('#standard-doggielawn').closest('.subscription-details').find('.product_list').addClass('active');
          $('#standard-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
        }, 300);
      } else if (app.rechargeData.currentSubscription.product_title.indexOf('Medium') > -1) {
        app.rechargeData.productJson = 'medium';
        if (app.rechargeData.currentSubscription.product_title.indexOf('Disposable DoggieLawn') > -1) {
          app.rechargeData.product_title_name = 'Medium Disposable DoggieLawn';
          app.rechargeData.currentSubscription.match_name = app.rechargeData.productJson;
        } else {
          app.rechargeData.product_title_name = 'Medium Doggielawn';
        }
        setTimeout(function () {
          $('#medium-doggielawn').closest('.subscription-details').find('.product_list').addClass('active');
          $('#medium-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
        }, 300);
      } else if (app.rechargeData.currentSubscription.product_title.indexOf('Large') > -1) {
        app.rechargeData.productJson = 'large';
        if (app.rechargeData.currentSubscription.product_title.indexOf('Disposable DoggieLawn') > -1) {
          app.rechargeData.product_title_name = 'Large Disposable DoggieLawn';
          app.rechargeData.currentSubscription.match_name = app.rechargeData.productJson;
        } else {
          app.rechargeData.product_title_name = 'Large Doggielawn';
        }
        setTimeout(function () {
          $('#large-doggielawn').closest('.subscription-details').find('.product_list').addClass('active');
          $('#large-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
        }, 300);
      } else if (app.rechargeData.currentSubscription.product_title.indexOf('XL') > -1) {
        $(app.selectors.productAccountObj).each(function (index, item) {
          var productObj = $(item).html();
          var productData = JSON.parse(productObj);
          // eslint-disable-next-line eqeqeq
          if (productData.id == app.rechargeData.currentSubscription.shopify_product_id) {
            app.rechargeData.productJson = productData.tag;
          }
        });

        app.rechargeData.product_title_name = 'XL Doggielawn';
        setTimeout(function () {
          $('#xl-doggielawn').closest('.subscription-details').find('.product_list').addClass('active');
          $('#xl-doggielawn').closest('.subscription-details').find('input').prop('checked', true);
        }, 300);
      } else if (app.rechargeData.currentSubscription.product_title == 'DoggieLawn') {
        if (app.rechargeData.currentSubscription.variant_title.toLowerCase().indexOf('doggielawn') > -1) {
          app.rechargeData.productJson = app.rechargeData.currentSubscription.variant_title.toLowerCase().split('doggielawn - ')[1];
        } else {
          app.rechargeData.productJson = app.rechargeData.currentSubscription.variant_title.toLowerCase();
        }

        app.rechargeData.product_title_name = app.rechargeData.currentSubscription.product_title;
        app.rechargeData.currentSubscription.match_name = app.rechargeData.productJson;
        setTimeout(function () {
          $("#" + app.rechargeData.productJson + "-doggielawn").closest('.subscription-details').find('.product_list').addClass('active');
          $("#" + app.rechargeData.productJson + "-doggielawn").closest('.subscription-details').find('input').prop('checked', true);
        }, 300);
      } else if (app.rechargeData.currentSubscription.product_title.indexOf('Avocado') > -1) {
        app.rechargeData.product_title_name = 'Avocado Toast Plush';
      }

      if (app.rechargeData.currentSubscription.product_title.indexOf('Bark Potty') > -1) {
        if (app.rechargeData.currentSubscription.variant_title.indexOf('Standard') > -1) {
          app.rechargeData.product_title_name = 'Standard Bark Potty';
          app.rechargeData.currentSubscription.match_name = 'Standard Bark Potty';
        } else {
          app.rechargeData.product_title_name = 'Large Bark Potty';
          app.rechargeData.currentSubscription.match_name = 'Large Bark Potty';
        }
      }
      var formatted_date = new Date(app.rechargeData.subscriptionsList[index].next_charge_scheduled_at);
      var time = $.parseHTML(app.shopifyDate);
      var currentDate = new Date(time[0].dateTime);
      currentDate.setDate(currentDate.getDate() + 30);

      if (formatted_date > currentDate) {
        app.hasEnableSkipBox = true;
      }

      var $siteOverlay = $(app.selectors.siteOverlay);
      if (!app.hasRechargePopup) {
        // open drawer
        app.isOverlayVisible = true;
        app.hasRechargePopup = true;
        app._focusToPopup();
        app._lockScroll();
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
        app.hasEnableSkipBox = false;
      }

      // app.hasRechargePopup = !app.hasRechargePopup;
      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.hasRechargePopup) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27) {
          app._closeDrawer();
        }
      });
      window.addEventListener('keydown', function (e) {
        if (app.hasRechargePopup) {
          app._handleKey(e);
        }
      });
      var nextdate = app.rechargeData.currentSubscription.next_charge_scheduled_at;
      var current_frequency = app.rechargeData.currentSubscription.order_interval_frequency;
      app.customFrequency.currentNextChargeDate = nextdate;
      app.customFrequency.currentFrequency = current_frequency;
    },
    _get_pastOrder: function _get_pastOrder() {
      var past_config = {
        data: {
          url: "/orders/?address_id=" + app.rechargeData.currentSubscription.address_id,
          method: 'GET'
        }
      };

      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', past_config).then(function (response) {
        console.log(response, "responce customm===========");
        $('[past_date]').html("<strong>By the way:</strong> Your last order processed on <span class=\"text-primary font-weight-bold\">" + moment(response.data.data.orders[0].processed_at).format('MMMM D, YYYY') + "</span>. It could be on it's way. Please check your order history for tracking details.");
      }).catch(function (error) {
        console.log(error);
      });
    },
    _handleKey: function _handleKey(e) {
      if (e.keyCode === 9) {
        var focusable = void 0;
        if ($('.confirm-popup.focused-popup').length) {
          // final result box
          if (document.querySelectorAll('.account-popup.opened .confirm-popup.focused-popup.open').length > 1) {
            var len = document.querySelectorAll('.account-popup.opened .confirm-popup.focused-popup.open').length;
            focusable = document.querySelectorAll('.account-popup.opened .confirm-popup.focused-popup.open')[len - 1].querySelectorAll('[tabindex]:not([tabindex="-1"]),[tabindex="0"],input:not([tabindex="-1"]),a,select:not([tabindex="-1"]),textarea');
          } else {
            focusable = document.querySelectorAll('.account-popup.opened .confirm-popup.focused-popup.open')[0].querySelectorAll('[tabindex]:not([tabindex="-1"]),[tabindex="0"],input:not([tabindex="-1"]),a,select:not([tabindex="-1"]),textarea');
          }
        } else if ($('.focused-popup.open').length) {
          // other boxes
          if (document.querySelectorAll('.account-popup.opened .focused-popup.open').length > 1) {
            var _len = document.querySelectorAll('.account-popup.opened .focused-popup.open').length;
            focusable = document.querySelectorAll('.account-popup.opened .focused-popup.open')[_len - 1].querySelectorAll('[tabindex]:not([tabindex="-1"]),[tabindex="0"],input:not([tabindex="-1"]),a,select:not([tabindex="-1"]),textarea');
          } else {
            focusable = document.querySelectorAll('.account-popup.opened .focused-popup.open')[0].querySelectorAll('[tabindex]:not([tabindex="-1"]),[tabindex="0"],input:not([tabindex="-1"]),a,select:not([tabindex="-1"]),textarea');
          }
        } else if ($('.modal-card-details.show').length) {
          // for subscription card details
          focusable = '';
        } else if ($('.default-box.open').length) {
          // default box
          focusable = document.querySelector('.account-popup.opened .default-box.open').querySelectorAll('[tabindex]:not([tabindex="-1"]),[tabindex="0"],input:not([tabindex="-1"]),a,select:not([tabindex="-1"]),textarea');
        }
        if (focusable != undefined) {
          if (focusable.length) {
            var first = focusable[0];
            var last = focusable[focusable.length - 1];
            var shift = e.shiftKey;
            if (shift) {
              if (e.target === first) {
                // shift-tab pressed on first input in dialog
                last.focus();
                e.preventDefault();
              }
            } else {
              if (e.target === last) {
                // tab pressed on last input in dialog
                first.focus();
                e.preventDefault();
              }
            }
          }
        }
      }
    },
    _focusToPopup: function _focusToPopup() {
      setTimeout(function () {
        if ($('.account-popup.opened .common-box.open a.popup-close').length) {
          if ($('.account-popup.opened .common-box.open a.popup-close').length > 1) {
            var acclen = $('.account-popup.opened .common-box.open a.popup-close').length;
            $($('.account-popup.opened .common-box.open a.popup-close')[acclen - 1]).trigger('focus');
          } else {
            $($('.account-popup.opened .common-box.open a.popup-close')[0]).trigger('focus');
          }
        } else if ($('.modal-card-details.show').length) {
          $('.modal-card-details.show a.popup-close').trigger('focus');
        }
      }, 200);
    },
    _toggleRechargeAddonsDrawer: function _toggleRechargeAddonsDrawer(event, index) {
      app.hasAddonsButton = false;
      $('body').addClass('popup-sub-open');
      app.rechargeData.currentSubscription = app.rechargeData.subscriptionsList[index];
      var $siteOverlay = $(app.selectors.siteOverlay);
      if (!app.hasRechargeAddonsPopup) {
        // open drawer
        app.isOverlayVisible = true;
        app.hasRechargeAddonsPopup = true;
        app._focusToPopup();
        window.addEventListener('keydown', function (e) {
          app._handleKey(e);
        });
        app._lockScroll();
        setTimeout(function () {
          var $carousel1 = $('[data-flickity-account-collections]');
          var options1 = {
            adaptiveHeight: false,
            contain: true,
            wrapAround: true,
            freeScroll: false,
            accessibility: true,
            cellAlign: "left",
            prevNextButtons: true,
            pageDots: false,
            draggable: true,
            groupCells: '100%',
            arrowShape: {
              "x0": 10,
              "x1": 60,
              "y1": 50,
              "x2": 60,
              "y2": 45,
              "x3": 15
            }
          };
          var flkty1 = new Flickity($carousel1[0], options1);
        }, 100);
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // app.hasRechargePopup = !app.hasRechargePopup;
      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.hasRechargeAddonsPopup) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27) {
          app._closeDrawer();
        }
      });
    },
    _toggleAddonsDrawer: function _toggleAddonsDrawer(event, category) {
      app.hasRechargePopup = false;
      app.hasaddonsEvent = false;
      app.hasAnyEvent = false;
      app.isOverlayVisible = false;
      app._unlockScroll();

      var $siteOverlay = $(app.selectors.siteOverlay);
      if (!app.hasRechargeAddonsPopup) {
        // open drawer
        app.isOverlayVisible = true;
        app.hasRechargeAddonsPopup = true;
        app._focusToPopup();
        window.addEventListener('keydown', function (e) {
          app._handleKey(e);
        });
        app._lockScroll();
        setTimeout(function () {
          var $carousel1 = $('[data-flickity-account-collections]');
          var options1 = {
            adaptiveHeight: false,
            contain: true,
            wrapAround: true,
            freeScroll: false,
            accessibility: true,
            cellAlign: "left",
            prevNextButtons: true,
            pageDots: false,
            draggable: true,
            groupCells: '100%',
            arrowShape: {
              "x0": 10,
              "x1": 60,
              "y1": 50,
              "x2": 60,
              "y2": 45,
              "x3": 15
            }
          };
          var flkty1 = new Flickity($carousel1[0], options1);
        }, 100);
        setTimeout(function () {
          if (category != '') {
            $('#' + category).trigger('click');
          }
        }, 150);
      } else {
        app.isOverlayVisible = false;
        app._unlockScroll();
      }

      // app.hasRechargePopup = !app.hasRechargePopup;
      $(document).on('keydown', function (e) {
        // close drawer
        if (!app.hasRechargeAddonsPopup) {
          return;
        }
        e = e || window.event;
        if (e.keyCode === 27) {
          app._closeDrawer();
        }
      });
    },
    _formatDateRecharge: function _formatDateRecharge(value) {
      var date = moment(value).format('MMM D, YYYY');
      return date;
    },
    _updateSubscriptionAPI: function _updateSubscriptionAPI(event) {

      var lastprocessDate = app.customFrequency.processDate;
      var updateFreq = app.updateProduct.selectedFreq;

      if (updateFreq == 'Every Week') {
        var pastDate = lastprocessDate.getDate() + 7;
        lastprocessDate.setDate(pastDate);
      } else if (updateFreq == 'Every 2 Weeks') {
        var pastDate = lastprocessDate.getDate() + 14;
        lastprocessDate.setDate(pastDate);
      } else if (updateFreq == 'Every 3 Weeks') {
        var pastDate = lastprocessDate.getDate() + 21;
        lastprocessDate.setDate(pastDate);
      } else if (updateFreq == 'Every 4 Weeks') {
        var pastDate = lastprocessDate.getDate() + 28;
        lastprocessDate.setDate(pastDate);
      }
      var newdate = new Date();

      var $target = $(event.currentTarget);
      app.isLoading = true;
      app.loadingEvent = 'update_subScription';

      var interval = 1;
      if (app.updateProduct.selectedFreq.indexOf('2') > -1) {
        interval = 2;
      } else if (app.updateProduct.selectedFreq.indexOf('3') > -1) {
        interval = 3;
      } else if (app.updateProduct.selectedFreq.indexOf('4') > -1) {
        interval = 4;
      }
      var Price = app._formatMoney(app.rechargeData.selectedVariant.price);
      Price = Price.replace('$', '');

      var oldPrice = app._formatMoney(app.rechargeData.currentSubscription.price);
      oldPrice = oldPrice.replace('$', '');

      var config = {
        data: {
          url: "/subscriptions/" + app.rechargeData.currentSubscription.id,
          method: 'PUT',
          data: {
            shopify_product_id: app.rechargeData.hasProductSelected.id,
            price: Price,
            shopify_variant_id: app.rechargeData.selectedVariant.id,
            product_title: app.rechargeData.newTitle,
            variant_title: app.rechargeData.selectedVariant.name,
            quantity: app.rechargeData.selectedVariant.quantity,
            order_interval_unit: 'week',
            order_interval_frequency: interval,
            charge_interval_frequency: interval,
            sku: app.rechargeData.selectedVariant.sku
          }
        }
      };
      //  console.log(config);
      //  return false;

      var flag = false;
      var offer = '';
      var limit = '';
      if (app.rechargeData.currentSubscription.properties) {
        app.rechargeData.currentSubscription.properties.forEach(function (prop) {
          // eslint-disable-next-line eqeqeq
          if (prop.name == 'action_type') {
            flag = true;
          }
          // eslint-disable-next-line eqeqeq
          if (prop.name == 'offer_type') {
            offer = prop.value;
          }
          // eslint-disable-next-line eqeqeq
          if (prop.name == 'no_of_times') {
            limit = prop.value;
          }
        });
      }

      if (flag === true) {
        var configRemove = {
          subscription_id: app.rechargeData.currentSubscription.id
        };
        // eslint-disable-next-line promise/catch-or-return
        axios.post('https://scripts.praella.com/doggielawn/remove_offer', configRemove)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          // eslint-disable-next-line promise/catch-or-return
          // eslint-disable-next-line promise/no-nesting
          rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
            if (response.data.data.error) {
              // Rollbar.error('Something went wrong', error);
              app._snotifyMsg('Error', response.data.data.error, 'Error');
              setTimeout(function () {
                app.isLoading = false;
                app.loadingEvent = null;
                app._getSubscriptions(app.customer.id);
                app._closeDrawer();
              }, 300);
              return false;
            } else if (response.data.data.warning === 'too many requests') {
              setTimeout(function () {
                app.isLoading = false;
                app.loadingEvent = null;
                app._getSubscriptions(app.customer.id);
                app._closeDrawer();
                // Rollbar.warning('Too many request');
              }, 300);
            } else if (response.data.data.errors) {
              app._snotifyMsg('Error', response.data.data.errors, 'Error');
              // Rollbar.error('Something went wrong', errors);
              return false;
            } else {
              app._updateAddonsFreq(response.data.data.subscription, lastprocessDate, newdate, flag, offer, limit, 'update subscription');
              return true;
            }
          });
        });
      } else {
        // eslint-disable-next-line promise/catch-or-return
        rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
          // eslint-disable-next-line promise/always-return
          if (response.data.data.error) {
            app._snotifyMsg('Error', response.data.data.error, 'Error');
            setTimeout(function () {
              app.isLoading = false;
              app.loadingEvent = null;
              app._getSubscriptions(app.customer.id);
              app._closeDrawer();
            }, 300);
            return false;
          } else if (response.data.data.warning === 'too many requests') {
            setTimeout(function () {
              app.isLoading = false;
              app.loadingEvent = null;
              app._getSubscriptions(app.customer.id);
              app._closeDrawer();
            }, 300);
          } else if (response.data.data.errors) {
            app._snotifyMsg('Error', response.data.data.errors, 'Error');
            return false;
          } else {
            app._updateAddonsFreq(response.data.data.subscription, lastprocessDate, newdate, flag, offer, limit, 'update subscription');
            return true;
          }
        });
      }
    },
    _updateAddonsFreq: function _updateAddonsFreq(sub, lastprocessDate, newdate, flag, offer, limit, type) {
      var updateFreqData = new FormData();
      updateFreqData.append('recharge_address_id', sub.address_id);
      updateFreqData.append('subscription_id', sub.id);
      //if(Object.keys(app.rechargeData.selectedpackageVariant).length != 0){
      if (app.rechargeData.packageProduct != '' && app.hasSkipBox == false) {
        updateFreqData.append('shopify_variant_id', app.rechargeData.selectedpackageVariant.id);
      }
      //console.log(Object.fromEntries(updateFreqData));
      axios({
        method: 'post',
        url: 'https://scripts.doggielawn.com/Doggielawn/update_connected_subscription.php',
        data: updateFreqData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // handle success
        // eslint-disable-next-line promise/always-return
        if (type === 'update subscription') {
          if (flag === true) {
            app._offerAdd('cancel', offer, limit, 'false');
            app._pointCheck();
            app._getSubscriptions(app.customer.id);
            var date = moment(sub.next_charge_scheduled_at).format('MMMM D, YYYY');
            app.rechargeData.currentSubscription = sub;
            app._mailSend('change', date);
            app.hasaddonsEvent = true;
            if (app.upgradePlan) {
              // if upgrade plan based on address
              app._snotifyMsg('Success', 'Your Subscription and address have been Updated Successfully.', 'Success');
            } else {
              // simple update
              app._snotifyMsg('Success', 'Your Subscription has been Updated Successfully.', 'Success');
            }
            setTimeout(function () {
              app.upgradePlan = false;
              app.isLoading = false;
              app.loadingEvent = null;
            }, 500);
          } else {
            // eslint-disable-next-line promise/always-return
            app._getSubscriptions(app.customer.id);
            var _date = moment(sub.next_charge_scheduled_at).format('MMMM D, YYYY');
            app.rechargeData.currentSubscription = sub;
            app._mailSend('change', _date);
            app.hasaddonsEvent = true;
            app._snotifyMsg('Success!', 'Your subscription(s) has been updated successfully.', 'Success');
            setTimeout(function () {
              app.isLoading = false;
              app.loadingEvent = null;
            }, 500);
            if (lastprocessDate < newdate) {
              app._setNextChargeDate();
            }
            setTimeout(function () {
              if (app.rechargeData.addonsOrders.length > 0) {
                app._updateAddons(_date);
              }
            }, 500);
          }
          if (app.rechargeData.packageProduct != '') {
            app._packageUpdateSubscription(app.rechargeData.packageProduct);
          }
        } else if (type === 'set next charge') {
          app._getSubscriptions(app.customer.id);
          var _date2 = moment(sub.next_charge_scheduled_at).format('MMMM D, YYYY');
          app._mailSend('skip', _date2);
          // eslint-disable-next-line eqeqeq
          if (app.loadingEvent.indexOf('activate_') == -1) {
            app.hasAnyEvent = true;
          }
          if (app.hasCancelCOVID50) {
            app._redeemOffer(event, '50', '1');
            app._snotifyMsg('Account Updated', 'Your account changes have been saved successfully.', 'Success');
          } else {
            app._snotifyMsg('Success!', 'Your subscription(s) has been updated successfully.', 'Success');
          }
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          if (app.rechargeData.addonsOrders.length > 0) {
            app._updateAddons(newdate);
          }
        }
      }).catch(function (response) {
        // handle error
        app.isLoading = false;
        app.loadingEvent = null;
      });
    },
    _packageUpdateSubscription: function _packageUpdateSubscription(packageProduct) {
      app.isLoading = true;
      app.loadingEvent = 'update_subScription';
      var interval = 1;
      if (app.rechargeData.selectedpackageVariant.title.indexOf('Every Week') > -1) {
        interval = 1;
      } else if (app.rechargeData.selectedpackageVariant.title.indexOf('2') > -1) {
        interval = 2;
      } else if (app.rechargeData.selectedpackageVariant.title.indexOf('3') > -1) {
        interval = 3;
      } else {
        interval = 4;
      }

      var Price = app._formatMoney(app.rechargeData.selectedpackageVariant.price);
      Price = Price.replace('$', '');

      var config = {
        data: {
          url: "/subscriptions/" + app.rechargeData.packageProduct.id,
          method: 'PUT',
          data: {
            shopify_product_id: app.rechargeData.packageProduct.shopify_product_id,
            price: Price,
            shopify_variant_id: app.rechargeData.selectedpackageVariant.id,
            product_title: app.rechargeData.packageProduct.product_title,
            variant_title: app.rechargeData.selectedpackageVariant.public_title,
            quantity: 1,
            order_interval_unit: 'week',
            order_interval_frequency: interval,
            charge_interval_frequency: interval,
            sku: app.rechargeData.selectedpackageVariant.sku
          }
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.error) {
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app._getSubscriptions(app.customer.id);
            app._closeDrawer();
          }, 300);
          return false;
        } else if (response.data.data.warning === 'too many requests') {
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app._getSubscriptions(app.customer.id);
            app._closeDrawer();
          }, 300);
        } else if (response.data.data.errors) {
          app._snotifyMsg('Error', response.data.data.errors, 'Error');
          return false;
        } else {
          app._snotifyMsg('Success!', 'Your subscription(s) has been updated successfully.', 'Success');
          return true;
        }
      });
    },
    _setNextChargeDate: function _setNextChargeDate() {

      var nextchargedate = app.customFrequency.currentNextChargeDate;

      var config = {
        data: {
          url: "/subscriptions/" + app.rechargeData.currentSubscription.id + "/set_next_charge_date",
          method: 'POST',
          data: {
            date: nextchargedate
          }
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {});
    },
    _addAddons: function _addAddons(event) {
      app.isLoading = true;
      var shopify_queue = [];
      var selected_addons = $(event.currentTarget).closest('.account-popup-addons').find('.popup-body .addons-product .subscription-details input:checked');
      var type = $(event.currentTarget).closest('.account-popup-addons').find('.popup-body .addons-product .subscription-details input:checked').data('addon');
      $.each(selected_addons, function (e) {
        var $target = $(this);
        var product_title = $target.attr('data-protitle');
        var product_price = $target.attr('data-proPrice');
        //var Finalprice = parseFloat(product_price.replace('$', ''));
        //  var Finalprice = app._formatMoney(product_price);

        var variantID = $target.attr('data-variantid');
        var prdID = $target.attr('data-prdId');
        var proImage = $target.attr('data-proImage');
        var productImg = app._getSizedImageUrl(proImage, 'medium');
        var subscriptionID = app.rechargeData.currentSubscription.id;
        if (type == 'onetime') {
          var config = {
            data: {
              url: "/onetimes/address/" + app.rechargeData.currentSubscription.address_id,
              method: 'POST',
              data: {
                next_charge_scheduled_at: app.rechargeData.currentSubscription.next_charge_scheduled_at,
                product_title: product_title,
                price: product_price,
                quantity: 1,
                shopify_variant_id: variantID,
                properties: [{
                  name: 'type',
                  value: 'addons'
                }, {
                  name: 'product-title',
                  value: product_title
                }, {
                  name: 'product-image',
                  value: productImg
                }, {
                  name: 'product-price',
                  value: product_price
                }, {
                  name: 'Subscription',
                  value: subscriptionID
                }]
              }
            }
          };
          shopify_queue.push({
            addons: config
          });
        } else if (type == 'recurring') {
          var subFormData = new FormData();
          subFormData.append('recharge_customer_id', app.rechargeData.rechargecustomerID);
          subFormData.append('subscription_id', app.rechargeData.currentSubscription.id);
          subFormData.append('shopify_product_id', prdID);
          subFormData.append('shopify_variant_id', variantID);
          subFormData.append('quantity', 1);
          subFormData.append('price', product_price);
          subFormData.append('product_property_image', productImg);

          axios({
            method: 'post',
            url: 'https://scripts.doggielawn.com/Doggielawn/recreate_subscription.php',
            data: subFormData,
            headers: { 'Content-Type': 'multipart/form-data' }
          })
          // eslint-disable-next-line promise/always-return
          .then(function (response) {
            // handle success
            // eslint-disable-next-line promise/always-return
            if (response.status == '0') {
              app.isLoading = false;
              app.loadingEvent = null;
              app._snotifyMsg('Error', response.status.message, 'Error');
              return false;
            } else {
              app.isLoading = false;
              app.loadingEvent = null;
              app.hasAddonsConfirm = true;
              app._snotifyMsg('Success!', 'Add-on product will be shipped with your upcoming order and all consecutive orders.', 'Success');
            }
          }).catch(function (response) {
            // handle error
            app.isLoading = false;
            app.loadingEvent = null;
          });
        }
      });

      app.isLoading = true;
      if (type == 'onetime') {
        Shopify.moveAlong = function () {

          if (shopify_queue.length) {
            var request = shopify_queue.shift();
            var data = request.addons;
            rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', data).then(function (response) {
              app.isLoading = false;
              Shopify.moveAlong();
              if (response.data.data.error) {
                app._snotifyMsg('Error', response.data.data.error, 'Error');
                return false;
              } else if (response.data.data.errors) {
                app._snotifyMsg('Error', response.data.data.errors, 'Error');
                return false;
              } else {
                app.hasAddonsConfirm = true;
                app._snotifyMsg('Success!', 'Add-on product will be shipped with your upcoming order.', 'Success');
                setTimeout(function () {
                  //$('.popup-close').trigger('click');
                  // window.location.reload;
                }, 2500);
              }
              return response;
            }).catch(function (error) {
              // console.log(error);
              if (shopify_queue.length) {
                Shopify.moveAlong();
              }
              app.isLoading = false;
              throw error;
            });
          }
        };

        Shopify.moveAlong();
      }
    },
    _updateAddons: function _updateAddons(date) {
      var Shopify_queue = [];
      app.rechargeData.addonsOrders.forEach(function (item) {
        if (item.address_id === app.rechargeData.currentSubscription.address_id) {
          var config_data = {
            data: {
              url: "/onetimes/" + item.id,
              method: 'PUT',
              data: {
                next_charge_scheduled_at: date
              }
            }
          };
          Shopify_queue.push({
            addons: config_data
          });
        }
      });
      Shopify.moveAlong = function () {
        if (Shopify_queue.length) {
          app.isAddonsUpdate = true;
          var request = Shopify_queue.shift();
          var data = request.addons;
          rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', data).then(function (response) {
            Shopify.moveAlong();
            return response;
          }).catch(function (error) {
            if (Shopify_queue.length) {
              Shopify.moveAlong();
            }
            throw error;
          });
        } else {
          app.isAddonsUpdate = false;
        }
      };
      Shopify.moveAlong();
    },
    _getAddonsOrders: function _getAddonsOrders() {
      var config = {
        data: {
          url: "/onetimes?customer_id=" + app.rechargeData.rechargecustomerID,
          method: 'GET',
          data: {}
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        if (response.data.data.error) {
          return false;
        } else {

          response.data.data.onetimes.forEach(function (order) {
            var img = order.properties.find(function (x) {
              return x.name == 'product-image';
            });
            if (img == undefined) {
              order.featured_image = null;
            } else {
              order.featured_image = img.value;
            }
          });
          app.rechargeData.addonsOrders = response.data.data.onetimes;
        }
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _cancelAddon: function _cancelAddon(productID) {
      app.isLoading = true;
      var config = {
        data: {
          url: "/onetimes/" + productID,
          method: 'DELETE',
          data: {}
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        app.isLoading = false;
        app.loadingEvent = null;
        if (response.data.data == null) {
          app._snotifyMsg('Success', 'Your product is successfully removed.', 'Success');
          app._getAddonsOrders();
        } else if (response.data.data.error) {
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          return false;
        } else {
          app._snotifyMsg('Success', 'Your product is successfully removed.', 'Success');
          app.isAddonsLoaded = true;
        }
        return response;
      }).catch(function (error) {
        // console.log(error);
        throw error;
      });
    },
    _getSubscriptions: function _getSubscriptions(id) {

      // IE11 bug: we need to disable cache for this request
      var config = {
        data: {
          shopify_customer_id: id,
          limit: 250
        }
      };

      rechargeSUbAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/subscription', config).then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.subscriptions !== undefined) {
          response.data.data.subscriptions.forEach(function (item) {
            var flag = false;
            item.properties.forEach(function (prop) {
              // eslint-disable-next-line eqeqeq
              if (prop.name == 'action_type') {
                flag = true;
              }
            });
            // eslint-disable-next-line eqeqeq
            if (flag) {
              item.offerApplied = true;
            } else {
              item.offerApplied = false;
            }

            if (item.variant_title.indexOf('Central local') > -1) {
              item.checkVariant = 'Central local';
            } else if (item.variant_title.indexOf('Eastern Local') > -1) {
              item.checkVariant = 'Eastern Local';
            } else if (item.variant_title.indexOf('Local Grass') > -1) {
              item.checkVariant = 'Local Grass';
            } else if (item.variant_title.indexOf('Original Hydroponic') > -1) {
              item.checkVariant = 'Original Hydroponic';
            } else if (item.variant_title.indexOf('Local') > -1) {
              item.checkVariant = 'Local';
            } else if (item.variant_title.indexOf('XL DoggieLawn') > -1) {
              item.checkVariant = 'Original Hydroponic';
            }
          });
          var SubArr = [];
          $(response.data.data.subscriptions).each(function (i, sub) {
            if (Object.keys(sub.properties.filter(function (ele) {
              return ele.name == 'addones';
            })).length == 0) {
              if (sub.status != 'CANCELLED' && sub.status != 'EXPIRED') {
                if (sub.product_title == "DoggieLawn Package Protection Auto renew") {
                  sub.isAddon = true;
                }
                SubArr.push(sub);
              }
            }
          });
          $(response.data.data.subscriptions).each(function (i, sub) {
            if (Object.keys(sub.properties.filter(function (ele) {
              return ele.name == 'addones';
            })).length == 0) {
              if (sub.status == 'CANCELLED') {
                SubArr.push(sub);
              }
            }
          });
          $(response.data.data.subscriptions).each(function (i, sub) {
            if (Object.keys(sub.properties.filter(function (ele) {
              return ele.name == 'addones';
            })).length == 0) {
              if (sub.status == 'EXPIRED') {
                SubArr.push(sub);
              }
            }
          });
          app.rechargeData.recurringAddons = [];
          $(response.data.data.subscriptions).each(function (i, sub) {
            if (Object.keys(sub.properties.filter(function (ele) {
              return ele.name == 'addones';
            })).length !== 0) {
              app.rechargeData.recurringAddons.push(sub);
            }
          });
          $(app.rechargeData.recurringAddons).each(function (i, sub) {
            $(SubArr).each(function (i, ele) {
              if (ele.address_id === sub.address_id) {
                SubArr.splice(i + 1, 0, sub);
                SubArr[i].isAddon = false;
                SubArr[i + 1].isAddon = true;
                return false; // breaks
              }
            });
          });

          app.rechargeData.subscriptionsList = SubArr;
          app.hasSubscription = true;
          setTimeout(function () {
            $('[data-addon="true"]').each(function (i, ele) {
              if ($(ele).next().data('addon')) {
                $(ele).addClass('border-bottom-0');
              }
            });
          }, 500);

          app._pointCheck();
          return response.data;
        } else {
          app.rechargeData.subscriptionsList = '';
          setTimeout(function () {
            app.hasSubscription = true;
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
        }
      }).then(function (response) {
        app._footableJs();
        return true;
      }).catch(function (error) {
        console.log(error);
        setTimeout(function () {
          app.isLoading = false;
          app.loadingEvent = null;
        }, 500);
        throw error;
      });
    },
    _getpackageProduct: function _getpackageProduct(id) {
      $(app.rechargeData.subscriptionsList).each(function (index, product) {
        if (product.address_id == id) {
          if (product.product_title == 'DoggieLawn Package Protection Auto renew') {
            app.rechargeData.packageProduct = product;
          }
        }
      });
    },
    _updateSubscription: function _updateSubscription(product) {
      console.log('product', product);
      var current_pr = $("[data-subscription-product-" + product + "-json]");
      var frequency_unit = "Week";
      if (app.rechargeData.currentSubscription.product_title == "DoggieLawn") {
        current_pr = $("[data-subscription-product-bundle-subscription-json]");
      } else if (app.rechargeData.currentSubscription.product_title.indexOf("Disposable DoggieLawn") > -1) {
        current_pr = $("[data-subscription-product-" + product + "-disposable-doggielawn-json]");
        frequency_unit = "week";
      } else if (app.rechargeData.currentSubscription.product_title.indexOf('Avocado') > -1) {
        current_pr = $('[data-subscription-product-avocadoproduct-json]');
        frequency_unit = 'week';
      } else if (app.rechargeData.currentSubscription.product_title.indexOf('Bark Potty') > -1) {
        current_pr = $("[data-subscription-product-" + app.rechargeData.currentSubscription.match_name.toLowerCase().replace(/ /g, '-') + "-json]");
        frequency_unit = 'week';
      }

      current_pr.each(function (index, itemX) {
        var productObj = $(itemX).html();
        var productData = JSON.parse(productObj);
        app.rechargeData.hasSubscriptionVariants = productData.variants;

        app.rechargeData.hasProductSelected = productData.product;
        if (product === 'group-2' || product === 'group-3') {
          setTimeout(function () {
            $('[data-freq-show]').each(function () {
              var textVal = $(this).find('[name-title]').text().toLowerCase();
              var textValActive = $(this).find('[name-title]').text();
              var dataXL = app.rechargeData.currentSubscription.variant_title.split('-')[1];
              // eslint-disable-next-line eqeqeq
              if (app.updateProduct.selectedGrass == '') {
                if (app.rechargeData.currentSubscription.variant_title.indexOf('Original') > -1) {
                  app.updateProduct.selectedGrass = 'original';
                } else if (app.rechargeData.currentSubscription.variant_title.indexOf('Central') > -1) {
                  app.updateProduct.selectedGrass = 'local grass';
                } else if (app.rechargeData.currentSubscription.variant_title.indexOf('Eastern') > -1) {
                  app.updateProduct.selectedGrass = 'local grass';
                } else if (app.rechargeData.currentSubscription.variant_title.indexOf('Local Grass') > -1) {
                  app.updateProduct.selectedGrass = 'local grass';
                } else if (app.rechargeData.currentSubscription.variant_title.indexOf('XL DoggieLawn') > -1) {
                  app.updateProduct.selectedGrass = 'original';
                }
              }
              console.log('textVal', textVal);
              if (textVal.indexOf(app.updateProduct.selectedGrass) > -1) {
                $(this).removeClass('d-none').addClass('d-flex');
              } else {
                $(this).addClass('d-none').removeClass('d-flex');
              }
              if (app.checkedBox) {
                // eslint-disable-next-line eqeqeq
                if ($.trim(textValActive) == $.trim(dataXL)) {
                  $(this).find('input').prop('checked', true);
                }
              }
            });
          }, 500);
        } else {
          $('[data-freq-show]').removeClass('d-none');
          if (app.checkedBox) {
            setTimeout(function () {
              var dataXL = "";
              if (parseInt(app.rechargeData.currentSubscription.order_interval_frequency) > 1) {
                dataXL = "Every " + app.rechargeData.currentSubscription.order_interval_frequency + " " + frequency_unit + "s";
              } else {
                dataXL = "Every " + frequency_unit;
              }

              $('[data-freq-show]').each(function () {
                var textValActive = $(this).find('[name-title]').text();

                // eslint-disable-next-line eqeqeq
                if ($.trim(textValActive) == $.trim(dataXL)) {
                  $(this).find('input').prop('checked', true);
                }
              });
            }, 500);
          }
        }
      });

      $("[data-subscription-product-packageproduct-json]").each(function (index, itemX) {
        var productObj = $(itemX).html();
        var productData = JSON.parse(productObj);
        app.rechargeData.hasSubscriptionpackageVariants = productData.variants;
        app.rechargeData.hasPackageProductSelected = productData.product;
      });
    },
    _selectButtonUpgrade: function _selectButtonUpgrade(event, eventType) {
      var check = $(event.currentTarget).closest('.subscription-details').find('.product_list').hasClass('active');
      var name = $('.product_list.active [data-name]').text();
      if (event.target.checked === true && check === false) {
        app.hasUpdateButton = true;
      } else {
        if ($.trim(name) === 'XL DoggieLawn') {
          app.hasUpdateButton = true;
        } else {
          app.hasUpdateButton = false;
        }
      }
      // eslint-disable-next-line eqeqeq
      app.rechargeData.currentSubscription.match_name = eventType;
    },
    _selectCollection: function _selectCollection(event, collection) {
      if (event.target.checked === true) {
        $(event.currentTarget).closest('.addons-collections').addClass('d-none');
        $(event.currentTarget).closest('.addons-collections').find('input').attr('tabindex', '-1');
        var options1 = {
          adaptiveHeight: false,
          contain: true,
          wrapAround: true,
          freeScroll: false,
          accessibility: true,
          cellAlign: "left",
          prevNextButtons: true,
          pageDots: false,
          draggable: true,
          groupCells: '100%',
          arrowShape: {
            "x0": 10,
            "x1": 60,
            "y1": 50,
            "x2": 60,
            "y2": 45,
            "x3": 15
          }
        };
        if (collection === 'bug-sprays') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-sprays').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-sprays').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel1 = $('[data-flickity-sprays-addons]');
            var flkty1 = new Flickity($carousel1[0], options1);
          }, 100);
        } else if (collection === 'grooming') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-grooming').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-grooming').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel2 = $('[data-flickity-grooming-addons]');
            var flkty2 = new Flickity($carousel2[0], options1);
          }, 100);
        } else if (collection === 'lawns') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-lawns').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-lawns').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel3 = $('[data-flickity-lawns-addons]');
            var flkty3 = new Flickity($carousel3[0], options1);
          }, 100);
        } else if (collection === 'toys') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-toys').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-toys').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel4 = $('[data-flickity-toys-addons]');
            var flkty4 = new Flickity($carousel4[0], options1);
          }, 100);
        } else if (collection === 'training-cleaning') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-training').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-training').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel5 = $('[data-flickity-training-addons]');
            var flkty5 = new Flickity($carousel5[0], options1);
          }, 100);
        } else if (collection === 'trays') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-trays').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-trays').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel6 = $('[data-flickity-trays-addons]');
            var flkty6 = new Flickity($carousel6[0], options1);
          }, 100);
        } else if (collection === 'treats') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-treats').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-treats').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel7 = $('[data-flickity-treats-addons]');
            var flkty7 = new Flickity($carousel7[0], options1);
          }, 100);
        } else if (collection === 'seasonal') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-seasonal').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-seasonal').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel8 = $('[data-flickity-seasonal-addons]');
            var flkty8 = new Flickity($carousel8[0], options1);
          }, 100);
        } else if (collection === 'bundles-sets') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-bundles-sets').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-bundles-sets').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel9 = $('[data-flickity-bundles-sets-addons]');
            var flkty9 = new Flickity($carousel9[0], options1);
          }, 100);
        } else if (collection === 'accessories') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-accessories').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-accessories').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel10 = $('[data-flickity-accessories-addons]');
            var flkty01 = new Flickity($carousel10[0], options1);
          }, 100);
        } else if (collection === 'bestseller') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-bestsellers').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-bestsellers').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel11 = $('[data-flickity-bestsellers-addons]');
            var flkty11 = new Flickity($carousel11[0], options1);
          }, 100);
        } else if (collection === 'new') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-new').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-new').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel12 = $('[data-flickity-new-addons]');
            var flkty12 = new Flickity($carousel12[0], options1);
          }, 100);
        } else if (collection === 'sale') {
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-sale').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-sale').find('input,select').attr('tabindex', '0');
          setTimeout(function () {
            var $carousel13 = $('[data-flickity-sale-addons]');
            var flkty13 = new Flickity($carousel13[0], options1);
          }, 100);
        } else if (collection === 'package-protection') {

          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-package-protection').removeClass('d-none');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-package-protection').find('input,select').attr('tabindex', '0');
          var currentSub_id = app.rechargeData.currentSubscription.variant_title.split('- ');
          var selected_id = $(event.currentTarget).closest('.addons-collections').nextAll('.collection-package-protection').find('select option[data-title="' + currentSub_id[1] + '"]').attr('data-variant-id');
          var selected_variant_title = currentSub_id[0].replace(' ', '-');
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-package-protection').find('input[data-addon="recurring"]').attr('data-variantid', selected_id);
          $(event.currentTarget).closest('.addons-collections').nextAll('.collection-package-protection').find('input[data-addon="recurring"]').attr('data-variantname', selected_variant_title);
          setTimeout(function () {
            var $carousel20 = $('[data-flickity-package-addons]');
            var flkty20 = new Flickity($carousel20[0], options1);
          }, 100);
        }
      }
    },
    _selectButtonAddonsUpgrade: function _selectButtonAddonsUpgrade(event) {
      //const check = $(event.currentTarget).closest('.subscription-details').find('.product_list').hasClass('active');
      $(event.currentTarget).parents('.account-popup-addons').find('.popup-body input').each(function () {
        if ($('.popup-body input:checked').length > 0) {
          if ($(event.currentTarget).parents('.addons-product').hasClass('collection-trays')) {
            if ($(event.currentTarget).parents('.collection-trays').find('.variant_dropdown').val() != '') {
              app.hasAddonsButton = true;
            } else {
              app.hasAddonsButton = false;
            }
          } else {
            app.hasAddonsButton = true;
          }

          $('[data-add-addons]').trigger('focus');
          $(event.currentTarget).closest('.card').addClass('border-green');
        } else {
          app.hasAddonsButton = false;
          $(event.currentTarget).closest('.card').removeClass('border-green');
        }
      });
    },
    _variantAddonsUpdate: function _variantAddonsUpdate(event) {
      var variantID = $(event.currentTarget).find('option:selected').val();
      var variantTitle = $.trim($(event.currentTarget).find('option:selected').text());

      var variantImages = $(event.currentTarget).closest('.card').find('[data-addons-tray-images]');
      $(event.currentTarget).closest('.card').find('[data-addons-tray-images]').each(function (index, ele) {
        var imageAlt = ele.getAttribute('alt');
        if (variantTitle == imageAlt) {
          var imageSrc = ele.getAttribute('src');
          ele.closest('.card-img').querySelector('[data-addons-tray-featured-img]').setAttribute('src', imageSrc);
        }
      });
      var variantPrice = $(event.currentTarget).find('option:selected').attr('data-variant-price');
      $(event.currentTarget).closest('.card-body').find('[data-price-details] span').text('$' + variantPrice);
      $(event.currentTarget).closest('.card-body').next('.card-footer').find('[data-addons-selector] input').attr('data-proPrice', variantPrice);
      $(event.currentTarget).closest('.card-body').next('.card-footer').find('[data-addons-selector] input').attr('data-variantID', variantID);
      if ($(event.currentTarget).val() != '') {
        if ($(event.currentTarget).parents('.addons-product').find('[data-addons-selector] input:checked').length > 0) {
          app.hasAddonsButton = true;
        } else {
          app.hasAddonsButton = false;
        }
      } else {
        app.hasAddonsButton = false;
      }
    },
    _selectButtonHide: function _selectButtonHide(event, eventType) {
      // eslint-disable-next-line eqeqeq
      if (eventType == 'pause_subscription' && event.target.checked === true) {
        app.hasSkipButton = false;
        app.rechargeData.currentSubscription.skipType = 'pause_subscription';
        app.rechargeData.buttonSkipText = 'Snooze Next Order';
        app._pauseDate(event);
        // eslint-disable-next-line eqeqeq
      } else if (eventType == 'skip_subscription' && event.target.checked === true) {
        app.hasSkipButton = true;
        app.rechargeData.currentSubscription.skipType = 'skip_subscription';
        app.rechargeData.buttonSkipText = 'Skip Next Order';
      }
    },
    _rechargePickYourPlan: function _rechargePickYourPlan(event) {
      var product = app.rechargeData.currentSubscription.match_name;
      if (product === undefined) {
        product = app.rechargeData.currentSubscription.product_title;
      }

      if (product === undefined) {
        // Rollbar.error("Update Subscriptions Error => Product is undefined");
      }

      if (product === 'xl' || product.indexOf('XL DoggieLawn') > -1) {
        app.hasUpdateBoxState = true;
      } else {
        app.hasUpdateBoxFreq = true;
        console.log('2');
        app._updateSubscription(product);
      }
      app._focusToPopup();
      // app.rechargeData.hasProductSelected = product;

    },
    _rechargeChangeState: function _rechargeChangeState(event) {
      // eslint-disable-next-line prefer-arrow-callback
      var state = $(event.currentTarget).find('option:selected').data('state');
      var group = $(event.currentTarget).val();
      if (state.toLowerCase() == app.rechargeData.address.province.toLowerCase().split(' ').join('-')) {
        app.shipAddMismatch = false;
        // eslint-disable-next-line eqeqeq
        if (group === 'group-3' || group === 'group-2') {
          app.hasUpdateBoxGrass = true;
          $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
          $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
          $('[data-grass]').removeClass('d-none');
          $('[data-frequently]').addClass('d-none');
          // eslint-disable-next-line eqeqeq
        }
        // else if (group === 'group-2') {
        //   app.hasUpdateBoxGrass = true;
        //   $('[data-grass-eastern]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass-original-group-3]').addClass('d-none').removeClass('d-flex');
        //   $('[data-grass]').removeClass('d-none');
        //   $('[data-frequently]').addClass('d-none');
        // } 
        else {
            app.hasUpdateBoxFreq = true;
            console.log('3');
            app._updateSubscription(group);
          }
        app.updateProduct.selectedStage = group;
        app.updateProduct.selectedState = state;
      } else {
        app.shipAddMismatch = true;
        app.hasUpdateBoxGrass = true;
        $('[data-grass-eastern]').addClass('d-none').removeClass('d-flex');
        $('[data-grass-original-group-3]').addClass('d-none').removeClass('d-flex');
        $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
        $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
      }
    },
    _updateGrass: function _updateGrass(event, grassType) {
      app.updateProduct.selectedGrass = grassType;
      app.hasUpdateBoxGrassButton = true;
    },
    _updateGrassButton: function _updateGrassButton(event) {
      console.log('4');
      app._updateSubscription(app.updateProduct.selectedStage);
      app.hasUpdateBoxFreq = true;
    },
    _updateFreqButton: function _updateFreqButton(event, variant) {
      app.updateProduct.selectedFreq = variant;
      if (app.hasUpdateBoxCheck) {
        // eslint-disable-next-line eqeqeq
        if (app.rechargeData.currentSubscription.variant_title.split('-')[2] != undefined) {
          var dataXL = app.rechargeData.currentSubscription.variant_title.split('-')[2];
          // eslint-disable-next-line eqeqeq
          if ($.trim(variant) != $.trim(dataXL)) {
            app.hasUpdateBoxCompareButton = true;
          } else {
            app.hasUpdateBoxCompareButton = false;
          }
        } else {
          var _dataXL = app.rechargeData.currentSubscription.variant_title.split('-')[1];
          // eslint-disable-next-line eqeqeq
          if ($.trim(variant) != $.trim(_dataXL)) {
            app.hasUpdateBoxCompareButton = true;
          } else {
            app.hasUpdateBoxCompareButton = false;
          }
        }
      } else {
        app.hasUpdateBoxCompareButton = true;
      }
    },
    _updateQtyButton: function _updateQtyButton(event) {
      var qty = $(event.target).closest('.input-group').find('[name="quantity"]').val();
    },
    _updateFreq: function _updateFreq(event) {
      var nextdate = app.customFrequency.currentNextChargeDate;
      var frequency = app.customFrequency.currentFrequency;
      var ourDate = new Date(nextdate);
      if (frequency == '1') {
        var pastDate = ourDate.getDate() - 7;
        ourDate.setDate(pastDate);
      } else if (frequency == '2') {
        var pastDate = ourDate.getDate() - 14;
        ourDate.setDate(pastDate);
      } else if (frequency == '3') {
        var pastDate = ourDate.getDate() - 21;
        ourDate.setDate(pastDate);
      } else if (frequency == '4') {
        var pastDate = ourDate.getDate() - 28;
        ourDate.setDate(pastDate);
      }
      app.customFrequency.processDate = ourDate;
      app.hasUpdateBoxCompare = true;

      $(app.rechargeData.hasSubscriptionVariants).each(function (index, item) {
        // eslint-disable-next-line eqeqeq
        if (item.public_title == app.updateProduct.selectedFreq) {
          app.rechargeData.selectedVariant = item;
          app.rechargeData.newTitle = app.rechargeData.hasProductSelected.title;
          app.rechargeData.hasProductSelected.title = app.rechargeData.hasProductSelected.title.split('-')[0];
          app.rechargeData.currentSubscription.product_title = app.rechargeData.currentSubscription.product_title.replace('Auto renew', '');

          if (app.updateProduct.selectedFreq.indexOf('Every Week') > -1) {
            app.updateProduct.selectedFreq = 'Every Week';
          } else if (app.updateProduct.selectedFreq.indexOf('2') > -1) {
            app.updateProduct.selectedFreq = 'Every 2 Weeks';
          } else if (app.updateProduct.selectedFreq.indexOf('3') > -1) {
            app.updateProduct.selectedFreq = 'Every 3 Weeks';
          } else if (app.updateProduct.selectedFreq.indexOf('4') > -1) {
            app.updateProduct.selectedFreq = 'Every 4 Weeks';
          }

          if (app.rechargeData.selectedVariant.public_title.indexOf('Every Week') > -1) {
            app.rechargeData.selectedVariant.public_title = 'Every Week';
          } else if (app.rechargeData.selectedVariant.public_title.indexOf('2') > -1) {
            app.rechargeData.selectedVariant.public_title = 'Every 2 Weeks';
          } else if (app.rechargeData.selectedVariant.public_title.indexOf('3') > -1) {
            app.rechargeData.selectedVariant.public_title = 'Every 3 Weeks';
          } else if (app.rechargeData.selectedVariant.public_title.indexOf('4') > -1) {
            app.rechargeData.selectedVariant.public_title = 'Every 4 Weeks';
          }

          if (app.rechargeData.currentSubscription.variant_title.indexOf('Every Week') > -1) {
            app.rechargeData.variant_title_name = 'Every Week';
          } else if (app.rechargeData.currentSubscription.variant_title.indexOf('2') > -1) {
            app.rechargeData.variant_title_name = 'Every 2 Weeks';
          } else if (app.rechargeData.currentSubscription.variant_title.indexOf('3') > -1) {
            app.rechargeData.variant_title_name = 'Every 3 Weeks';
          } else if (app.rechargeData.currentSubscription.variant_title.indexOf('4') > -1) {
            app.rechargeData.variant_title_name = 'Every 4 Weeks';
          }
          app.rechargeData.selectedVariant.quantity = $('[data-sub-qty]').val();
        }

        if (app.rechargeData.currentSubscription.product_title == 'DoggieLawn') {
          if (item.public_title.toLowerCase() == app.rechargeData.currentSubscription.match_name) {
            app.rechargeData.selectedVariant = item;
            app.rechargeData.newTitle = app.rechargeData.hasProductSelected.title;

            if (app.rechargeData.currentSubscription.order_interval_frequency == '1') {
              app.rechargeData.variant_title_name = 'Every Week';
              app.rechargeData.selectedVariant.public_title = app.updateProduct.selectedFreq;
            } else {
              app.rechargeData.variant_title_name = "Every " + app.rechargeData.currentSubscription.order_interval_frequency + " Weeks";
              app.rechargeData.selectedVariant.public_title = app.updateProduct.selectedFreq;
            }
          }
          app.rechargeData.selectedVariant.quantity = $('[data-sub-qty]').val();
        }
      });

      $(app.rechargeData.hasSubscriptionpackageVariants).each(function (index, PackageItem) {
        if (PackageItem.public_title == app.updateProduct.selectedFreq) {
          app.rechargeData.selectedpackageVariant = PackageItem;
        }
      });
    },
    _getNextChargeDate: function _getNextChargeDate(event, eventType) {
      var nextChargeDate = app._formatDate(app.rechargeData.currentSubscription.next_charge_scheduled_at);
      var SimplenextChargeDate = '';

      // eslint-disable-next-line eqeqeq
      if (eventType == 'pause_subscription') {
        nextChargeDate = app.rechargeData.pauseDate;
        SimplenextChargeDate = $('[data-pause-date]').val();
      } else {
        nextChargeDate = moment(app.rechargeData.currentSubscription.next_charge_scheduled_at).add(app.rechargeData.currentSubscription.charge_interval_frequency, 'week').format('MMMM D, YYYY');
        SimplenextChargeDate = moment(app.rechargeData.currentSubscription.next_charge_scheduled_at).add(app.rechargeData.currentSubscription.charge_interval_frequency, 'week').format('Y-MM-DD');
      }
      app.rechargeData.nextChargeFormats = nextChargeDate;
      app.rechargeData.skipDateResponse.skip_next_charge_date = SimplenextChargeDate + "T00:00:00";
    },
    _updateNextChargeDate: function _updateNextChargeDate(id) {
      var dateD = moment(app.rechargeData.skipDateResponse.skip_next_charge_date).format('YYYY-MM-DD');
      app.isLoading = true;
      app.loadingEvent = 'skipSubscription';
      var config = {
        data: {
          url: "/subscriptions/" + id + "/set_next_charge_date",
          method: 'POST',
          data: {
            date: dateD
          }
        }
      };

      // eslint-disable-next-line eqeqeq
      if (app.hasCancelBox3 == true && app.hasCancelBoxDig == true) {
        // eslint-disable-next-line promise/catch-or-return
        axios.post("https://scripts.doggielawn.com/Doggielawn/email-script.php?email=" + app.customer.email + "&name=" + app.customer.name)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {});
      }

      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        if (response.data.data.error) {
          // Rollbar.error('Something went wrong', error);
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          return false;
        } else {
          app._updateAddonsFreq(response.data.data.subscription, null, dateD, null, null, null, 'set next charge');
          return true;
        }
      }).catch(function (error) {
        app.isLoading = null;
        app.loadingEvent = null;
        console.log(error);
        // Rollbar.critical('Something went wrong', error);
      });
    },
    _getChangeShippingAddress: function _getChangeShippingAddress() {
      $('body').keyup('.edit-shipping-box input,.edit-shipping-box textarea', function () {
        app.hasUpdateAddress = true;
      });
      $('body').change('.edit-shipping-box select', function () {
        app.hasUpdateAddress = true;
      });
    },
    _getChangeBillingAddress: function _getChangeBillingAddress() {
      $('body').keyup('.edit-billing-box input,.edit-billing-box textarea', function () {
        app.hasUpdateBillingAddress = true;
      });
      $('body').change('.edit-billing-box select', function () {
        app.hasUpdateBillingAddress = true;
      });
    },
    _getAddress: function _getAddress(address_id) {
      var config = {
        data: {
          url: "/addresses/" + address_id,
          method: 'GET'
        }
      };

      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        if (response.data.error) {
          return false;
        } else {
          app.rechargeData.address = response.data.data.address;
          return true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    _updateAddress: function _updateAddress(address_id) {

      if (address_id == null || address_id === undefined) {
        // Rollbar.error('Update Shipping Address => Not Found Address ID');
      }
      var address_first_name = $('[data-first-name]').val();
      var address_last_name = $('[data-last-name]').val();
      var address_address1 = $('[data-address1]').val();
      var address_address2 = $('[data-address2]').val();
      var address_city = $('[data-city]').val();
      var address_province_group = $('[data-province]').find('option:selected').val();
      var address_province = $('[data-province]').find('option:selected').text().trim();
      var address_country = $('[data-country]').val();
      var address_zip = $('[data-zip]').val();
      var address_company = $('[data-company]').val();
      var address_phone = $('[data-phone]').val();

      console.log('address_province_group', address_province_group);
      if (app.rechargeData.currentSubscription.product_title === 'XL DoggieLawn') {
        if (app.rechargeData.currentSubscription.checkVariant === 'Central local' || app.rechargeData.currentSubscription.checkVariant === 'Eastern Local' || app.rechargeData.currentSubscription.checkVariant === 'Local Grass' || app.rechargeData.currentSubscription.checkVariant === 'Original Hydroponic') {
          // address_province_group != app.rechargeData.productJson #Backup If condition
          if (address_province_group != app.rechargeData.productJson && (address_province_group == 'group-1' || app.rechargeData.productJson == 'group-1')) {

            app.shipAddMismatchWarning = true;
            if (address_province_group == 'group-1') {
              app.hasUpdateBoxFreq = true;
              app.hasAddressBox = false;
              app._updateSubscription(address_province_group);
            } else if (address_province_group === 'group-3') {
              app.hasUpdateBoxGrass = true;
              $('[data-grass-central]').addClass('d-none').removeClass('d-flex');
              $('[data-grass-original-group-2]').addClass('d-none').removeClass('d-flex');
              $('[data-grass]').removeClass('d-none');
              $('[data-frequently]').addClass('d-none');
              app.updateProduct.selectedStage = address_province_group;
              app.updateProduct.selectedState = address_province;
              // eslint-disable-next-line eqeqeq
            } else if (address_province_group === 'group-2') {
              app.hasUpdateBoxGrass = true;
              $('[data-grass-eastern]').addClass('d-none').removeClass('d-flex');
              $('[data-grass-original-group-3]').addClass('d-none').removeClass('d-flex');
              $('[data-grass]').removeClass('d-none');
              $('[data-frequently]').addClass('d-none');
              app.updateProduct.selectedStage = address_province_group;
              app.updateProduct.selectedState = address_province;
            }
            app._updateAddressApi(address_id, address_province, address_first_name, address_last_name, address_address1, address_address2, address_city, address_country, address_zip, address_company, address_phone);
            // eslint-disable-next-line eqeqeq
          } else {
            app.shipAddMismatchWarning = false;
            app._updateAddressApi(address_id, address_province, address_first_name, address_last_name, address_address1, address_address2, address_city, address_country, address_zip, address_company, address_phone);
          }
        } else if (app.rechargeData.currentSubscription.checkVariant === undefined) {
          app._updateAddressApi(address_id, address_province, address_first_name, address_last_name, address_address1, address_address2, address_city, address_country, address_zip, address_company, address_phone);
        }
      } else {
        app._updateAddressApi(address_id, address_province, address_first_name, address_last_name, address_address1, address_address2, address_city, address_country, address_zip, address_company, address_phone);
      }
    },
    _updateAddressApi: function _updateAddressApi(address_id, address_province, address_first_name, address_last_name, address_address1, address_address2, address_city, address_country, address_zip, address_company, address_phone) {
      var config = '';
      app.isLoading = true;
      app.loadingEvent = 'update_address';
      if (address_province == null) {
        // eslint-disable-next-line no-var
        config = {
          data: {
            url: "/addresses/" + address_id,
            method: 'PUT',
            data: {
              first_name: address_first_name,
              last_name: address_last_name,
              address1: address_address1,
              address2: address_address2,
              company: address_company,
              city: address_city,
              country: address_country,
              zip: address_zip,
              phone: address_phone
            }
          }
        };
      } else {
        // eslint-disable-next-line no-redeclare
        config = {
          data: {
            url: "/addresses/" + address_id,
            method: 'PUT',
            data: {
              first_name: address_first_name,
              last_name: address_last_name,
              address1: address_address1,
              address2: address_address2,
              company: address_company,
              city: address_city,
              country: address_country,
              zip: address_zip,
              phone: address_phone,
              province: address_province
            }
          }
        };
      }

      // eslint-disable-next-line block-scoped-var
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        if (response.data.data.error) {
          app.isLoading = false;
          app.loadingEvent = null;
          if (response.data.data.error.zip) {
            // Rollbar.error('Added wrong zipcode in update shipping address API', response.data.data.error.zip);
            app._snotifyMsg('Wrong Zipcode', response.data.data.error.zip, 'Error');
          } else if (response.data.data.error.province) {
            // Rollbar.error('Added wrong province in update shipping address API', response.data.data.error.province);
            app._snotifyMsg('Wrong Province', response.data.data.error.province, 'Error');
          } else {
            // Rollbar.error('Something went wrong in update shipping address API', error);
            app._snotifyMsg('Error', response.data.data.error, 'Error');
          }
          return false;
        } else {
          app._mailSendForAddress(address_address1, address_address2, address_company, address_city, address_country, address_zip, address_province);
          // app._getAddress(app.rechargeData.currentSubscription.address_id);
          // app._closeDrawer();
          if (app.shipAddMismatchWarning == false) {
            app._snotifyMsg('Success', 'Your Address has been Updated Successfully.', 'Success');
          }

          setTimeout(function () {
            if (app.shipAddMismatchWarning == true) {
              app.hasAddressBox = false;
            } else {
              app.hasAnyEvent = true;
            }
            if (app.shipAddMismatchWarning == false) {
              app._getSubscriptions(app.customer.id);
            }
            app.isLoading = false;
            app.loadingEvent = null;
          }, 2000);
          return true;
        }
      }).catch(function (error) {
        ROllbar.error('Something went wrong', error);
        console.log(error);
      });
    },
    _updateBillingAddress: function _updateBillingAddress(customer_id) {
      var address_first_name = $('[data-billing-first-name]').val();
      var address_last_name = $('[data-billing-last-name]').val();
      var address_address1 = $('[data-billing-address1]').val();
      var address_address2 = $('[data-billing-address2]').val();
      var address_city = $('[data-billing-city]').val();
      var address_province = $('[data-billing-province]').val();
      var address_country = $('[data-billing-country]').val();
      var address_zip = $('[data-billing-zip]').val();
      var address_company = $('[data-billing-company]').val();
      var address_phone = $('[data-billing-phone]').val();
      var config = '';
      app.isLoading = true;
      app.loadingEvent = 'update_address';

      if (address_province == null) {
        // eslint-disable-next-line no-var
        config = {
          data: {
            url: "/customers/" + customer_id,
            method: 'PUT',
            data: {
              first_name: address_first_name,
              last_name: address_last_name,
              billing_address1: address_address1,
              billing_address2: address_address2,
              billing_company: address_company,
              billing_city: address_city,
              billing_country: address_country,
              billing_zip: address_zip,
              billing_phone: address_phone
            }
          }
        };
      } else {
        // eslint-disable-next-line no-redeclare
        config = {
          data: {
            url: "/customers/" + customer_id,
            method: 'PUT',
            data: {
              first_name: address_first_name,
              last_name: address_last_name,
              billing_address1: address_address1,
              billing_address2: address_address2,
              billing_company: address_company,
              billing_city: address_city,
              billing_country: address_country,
              billing_zip: address_zip,
              billing_phone: address_phone,
              billing_province: address_province
            }
          }
        };
      }

      // eslint-disable-next-line block-scoped-var
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        if (response.data.data.error) {
          app.isLoading = false;
          app.loadingEvent = null;
          if (response.data.data.error.zip) {
            app._snotifyMsg('Wrong Zipcode', response.data.data.error.zip, 'Error');
          } else if (response.data.data.error.province) {
            app._snotifyMsg('Wrong Province', response.data.data.error.province, 'Error');
          } else {
            app._snotifyMsg('Error', response.data.data.error, 'Error');
          }
          return false;
        } else {
          app._mailSendForBillingAddress(address_address1, address_address2, address_company, address_city, address_country, address_zip, address_province);
          // app._getAddress(app.rechargeData.currentSubscription.address_id);
          // app._closeDrawer();
          app.hasAnyEvent = true;
          app._snotifyMsg('Success', 'Your Billing Address has been Updated Successfully.', 'Success');
          setTimeout(function () {
            app._getSubscriptions(app.customer.id);
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          return true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    _getReasonFromOptions: function _getReasonFromOptions(event) {
      var currentOption = $(event.currentTarget).find('option:selected').data('value');
      // eslint-disable-next-line eqeqeq
      if (currentOption == 'no_reason') {
        app.hasCancelBtn = false;
      } else {
        app.hasCancelBtn = true;
      }
    },
    _checkCancelDigKit: function _checkCancelDigKit(event) {
      var type = $('[data-cancellation-dig]').val();
      if (type === 'yes') {
        app.hasCancelBox4 = true;
        // eslint-disable-next-line promise/catch-or-return
        axios.post("https://scripts.doggielawn.com/Doggielawn/email-script.php?email=" + app.customer.email + "&name=" + app.customer.name)
        // eslint-disable-next-line promise/always-return
        .then(function (response) {
          // result
        });
      } else if (type === 'snooze-yes') {
        app.hasCancelBox3 = true;
        setTimeout(function () {
          var date = app.rechargeData.currentSubscription.next_charge_scheduled_at.split('T')[0];
          $('[data-pause-date-skip]').flatpickr({
            minDate: 'today',
            altInput: true,
            altFormat: 'F j, Y',
            onChange: function onChange(val) {
              $('[data-text-show], [data-button-show]').removeClass('d-none');
              var dateSkip = moment(val[0]).format('MMMM D, YYYY');
              app.rechargeData.snoozeSkipDate = dateSkip;
              app.rechargeData.buttonSkipText = "Snooze my next subscription process date until " + dateSkip;
            },

            disable: [
              //  function(date) {
              //    return date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 5 || date.getDay() === 6; // disable weekends
              //  },
            ]
          });
        }, 300);
      } else {
        app.hasCancelBox5 = true;
      }
    },
    _checkCancelShipping: function _checkCancelShipping(event) {
      app.hasCancelshipping = false;
      app.shippingReason = $('[data-cancellation-shipping] option:selected').attr('value');
      if (app.shippingReason == 'something_else') {
        app.shippingReason = "Something else : " + $('[data-shipping-message]').val();
      }
      if (!app.hasOfferAdded) {
        app.hasCancelBox2 = true;
      } else {
        app.hasCancelBoxshipping = true;
      }
    },
    _checkCancelReasonDiscount: function _checkCancelReasonDiscount(event) {
      app.hasCancelBox2 = true;
    },
    _pauseDate: function _pauseDate(event) {
      var date = app.rechargeData.currentSubscription.next_charge_scheduled_at.split('T')[0];
      $('[data-pause-date]').flatpickr({
        minDate: 'today',
        altInput: true,
        altFormat: 'F j, Y',
        onChange: function onChange(val) {
          // eslint-disable-next-line eqeqeq
          if (app.rechargeData.currentSubscription.skipType == 'pause_subscription') {
            app._getNextChargeDate(event, 'pause_subscription');
            app.hasSkipButton = true;
            var dateSkip = moment(val[0]).format('MMMM D, YYYY');
            app.rechargeData.pauseDate = dateSkip;
            app.rechargeData.buttonSkipText = "Process next order on " + dateSkip;
          }
        },

        disable: [
          //  function(date) {
          //    return date.getDay() === 0 || date.getDay() === 1 || date.getDay() === 2 || date.getDay() === 3 || date.getDay() === 5 || date.getDay() === 6; // disable weekends
          //  },
        ]
      });
    },
    _skipPauseFromCancel: function _skipPauseFromCancel(event) {
      // eslint-disable-next-line eqeqeq
      var nextChargeDate = $('[data-pause-date-skip]').val();
      // eslint-disable-next-line eqeqeq
      if (nextChargeDate != '') {
        app.rechargeData.nextChargeFormats = moment(nextChargeDate).format('MMMM D, YYYY');
        app.rechargeData.skipDateResponse.skip_next_charge_date = nextChargeDate + "T00:00:00";
        app._updateNextChargeDate(app.rechargeData.currentSubscription.id);
      }
    },
    _redeemOffer: function _redeemOffer(event, discounted, count) {
      app.isLoading = true;
      app.loadingEvent = 'redeem_offer';
      app._offerAdd('cancel', discounted, count, 'true');
    },
    _swapCancelSelection: function _swapCancelSelection(event) {
      if (!app.hasOfferAdded) {
        app.hasCancelBox2 = true;
      } else {
        app.hasCancelBox5 = true;
      }
    },
    _swapSubscription: function _swapSubscription(productID, variantID, price) {
      app.isLoading = true;

      var config = {
        data: {
          url: "/subscriptions/" + app.rechargeData.currentSubscription.id,
          method: 'PUT',
          data: {
            shopify_product_id: productID,
            price: price,
            shopify_variant_id: variantID,
            quantity: "1",
            order_interval_unit: 'week',
            order_interval_frequency: "1",
            charge_interval_frequency: "1"
          }
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.error) {
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app._getSubscriptions(app.customer.id);
            app._closeDrawer();
          }, 300);
          return false;
        } else if (response.data.data.warning === 'too many requests') {
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app._getSubscriptions(app.customer.id);
            app._closeDrawer();
          }, 300);
        } else if (response.data.data.errors) {
          app._snotifyMsg('Error', response.data.data.errors, 'Error');
          return false;
        } else {
          app.isLoading = false;
          app.loadingEvent = null;
          app._getSubscriptions(app.customer.id);
          app._closeDrawer();
        }
      });
    },
    _checkCancelReason: function _checkCancelReason(event) {
      var reason = $('[data-cancellation-reason] option:selected').attr('data-value');
      app.rechargeData.CancelReason = reason;
      console.log('reason', reason);
      switch (reason) {
        case 'wont_use':
          //app.hasCancelBox1 = true;
          app.hasCancelBox2 = true;
          break;
        case 'digging_biting':
          app.hasCancelBoxDig = true;
          break;
        case 'dog_outside':
          app.hasCancelBox2 = true;
          break;
        case 'moving_home':
          app.hasCancelBox2 = true;
          break;
        case 'financial':
          if (!app.hasOfferAdded) {
            app.hasCancelBox2 = true;
          } else {
            app.hasCancelBox5 = true;
          }
          break;
        case 'dog_crossed_rainbow_bridge':
          app.hasCancelBox5 = true;
          break;
        case 'no_longer_dog':
          app.hasCancelBox5 = true;
          break;
        case 'product_issue':
          // if (!app.hasOfferAdded) {
          //   app.hasCancelBox2 = true;
          // } else {
          //   app.hasCancelBox6 = true;
          // }

          if (!app.hasOfferAdded) {
            app.hasCancelBox2 = true;
          } else {
            app.hasCancelBox5 = true;
          }
          break;
        case 'nothing':
          app.cancel_confirm = true;
          break;
        case 'shipping_issue':
          app.hasCancelshipping = true;
          // if(!app.hasOfferAdded){
          //   app.hasCancelBox2 = true;
          // } else{
          //   app.hasCancelBox5 = true;
          // }
          break;
        case 'period_time':
          app.hasCancelBox2 = true;
          break;
        case 'other_reason':
          // eslint-disable-next-line no-case-declarations
          if (!app.hasOfferAdded) {
            var flag = false;
            if (app.rechargeData.currentSubscription.properties) {
              app.rechargeData.currentSubscription.properties.forEach(function (prop) {
                // eslint-disable-next-line eqeqeq
                if (prop.name == 'action_type') {
                  flag = true;
                }
              });
            }
            if (flag) {
              app.hasCancelBox5 = true;
            } else {
              app.hasCancelBoxCovid = true;
            }
          } else {
            app.hasCancelBox5 = true;
          }
          break;
      }
    },
    _reasonHide: function _reasonHide() {
      if (app.rechargeData.currentSubscription.properties) {
        var flag = false;
        app.rechargeData.currentSubscription.properties.forEach(function (prop) {
          // eslint-disable-next-line eqeqeq
          if (prop.name == 'action_type') {
            flag = true;
          }
        });

        if (flag === true) {
          $('[data-api-call]').addClass('d-none');
        } else {
          $('[data-api-call]').removeClass('d-none');
        }
      }
    },
    _cancelSubscription: function _cancelSubscription(event, id) {
      var currentVal = $('[data-comment]').val();
      var cancellationValue = $('[data-cancellation-reason]').val();
      var checkReason = $('[data-cancellation-reason] option:selected').attr('data-value');

      // eslint-disable-next-line eqeqeq
      if (checkReason == 'other_reason' && currentVal == '') {
        $('[data-comment]').removeClass('border-black').addClass('border-danger');
        return false;
      } else if (checkReason === 'dog_crossed_rainbow_bridge') {
        currentVal = cancellationValue;
      }

      if (app.rechargeData.currentSubscription.properties) {
        app.rechargeData.currentSubscription.properties.forEach(function (prop) {
          // eslint-disable-next-line eqeqeq
          if (prop.name == 'action_type') {
            app._offerRemove();
          }
        });
        setTimeout(function () {
          app._cancelSub(id, cancellationValue, currentVal);
        }, 1500);
      }
    },
    _cancelSub: function _cancelSub(id, cancellationValue, currentVal) {
      app.isLoading = true;
      app.loadingEvent = 'cancel_subScription';
      var config = {
        data: {
          url: "/subscriptions/" + id + "/cancel",
          method: 'POST',
          data: {
            cancellation_reason: cancellationValue,
            cancellation_reason_comments: currentVal,
            send_email: true
          }
        }
      };

      setTimeout(function () {
        rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {

          setTimeout(function () {
            if (response.data.data.error != null) {
              // Rollbar.error('Something Went Wrong In Cancel Subscriptions', response.data.data.error);
              app._snotifyMsg('Error', response.data.data.error, 'Error');
            } else {
              app._snotifyMsg('Success', 'Your Subscription has been Successfully cancelled.', 'Success');
              var currentSubscriptionID = app.rechargeData.currentSubscription.id;
              app._callDeleteRechargeAddons(currentSubscriptionID);
              if (app.rechargeData.currentSubscription.recurringAddons.length) {
                app._callDeleteRechargeRecurringAddons(app.rechargeData.currentSubscription.address_id, cancellationValue, currentVal);
              }
              if (app.rechargeData.CancelReason == "shipping_issue") {
                app._mailSend('cancel', '');
              }
            }
            app._getSubscriptions(app.customer.id);
            if (!app.rechargeData.currentSubscription.recurringAddons.length) {
              app.hasCancelBox4 = true;
              app.hasCancelBoxFinal = true;
            }
            setTimeout(function () {
              app.isLoading = false;
              app.loadingEvent = null;
            }, 500);
            return true;
          }, 500);
          if (app.rechargeData.packageProduct != '') {
            app._packageCancelSubscription(app.rechargeData.packageProduct.id);
          }
          return response;
        }).catch(function (error) {
          // Rollbar.critical('Something Went Wrong In Cancel Subscriptions', error);
          console.log(error);
        });
      }, 2000);
    },
    _packageCancelSubscription: function _packageCancelSubscription(id) {

      var currentVal = $('[data-comment]').val();
      var cancellationValue = $('[data-cancellation-reason]').val();
      var checkReason = $('[data-cancellation-reason] option:selected').attr('data-value');

      // eslint-disable-next-line eqeqeq
      if (checkReason == 'other_reason' && currentVal == '') {
        $('[data-comment]').removeClass('border-black').addClass('border-danger');
        return false;
      } else if (checkReason === 'dog_crossed_rainbow_bridge') {
        currentVal = cancellationValue;
      }

      if (app.rechargeData.currentSubscription.properties) {
        app.rechargeData.currentSubscription.properties.forEach(function (prop) {
          // eslint-disable-next-line eqeqeq
          if (prop.name == 'action_type') {
            app._offerRemove();
          }
        });
        setTimeout(function () {

          app.isLoading = true;
          app.loadingEvent = 'cancel_subScription';
          var config = {
            data: {
              url: "/subscriptions/" + id + "/cancel",
              method: 'POST',
              data: {
                cancellation_reason: cancellationValue,
                cancellation_reason_comments: currentVal,
                send_email: true
              }
            }
          };

          setTimeout(function () {
            rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
              setTimeout(function () {
                if (response.data.data.error != null) {
                  app._snotifyMsg('Error', response.data.data.error, 'Error');
                } else {
                  app._snotifyMsg('Success', 'Your Subscription has been Successfully cancelled.', 'Success');
                  var currentSubscriptionID = app.rechargeData.currentSubscription.id;
                  app._callDeleteRechargeAddons(currentSubscriptionID);
                  if (app.rechargeData.currentSubscription.recurringAddons.length) {
                    app._callDeleteRechargeRecurringAddons(app.rechargeData.currentSubscription.address_id, cancellationValue, currentVal);
                  }
                }
                app._getSubscriptions(app.customer.id);
                if (!app.rechargeData.currentSubscription.recurringAddons.length) {
                  app.hasCancelBox4 = true;
                  app.hasCancelBoxFinal = true;
                }
                setTimeout(function () {
                  app.isLoading = false;
                  app.loadingEvent = null;
                }, 500);
                return true;
              }, 500);
              return response;
            }).catch(function (error) {
              console.log(error);
            });
          }, 2000);
        }, 1500);
      }
    },
    _callDeleteRechargeAddons: function _callDeleteRechargeAddons(currentSubscriptionID) {
      var addonsOrder = app.rechargeData.addonsOrders;
      if (addonsOrder.length > 0) {
        var shopify_queue = [];
        addonsOrder.forEach(function (order) {
          var addonsSubscriptionID = order.properties[4].value;
          if (currentSubscriptionID == addonsSubscriptionID) {
            var productID = order.id;

            var config = {
              data: {
                url: "/onetimes/" + productID,
                method: 'DELETE',
                data: {}
              }
            };
            shopify_queue.push({
              addons: config
            });
            //app._deleteRechargeAddons(productID);
          }
        });
        app.isLoading = true;
        Shopify.moveAlong = function () {
          if (shopify_queue.length) {
            var request = shopify_queue.shift();
            var data = request.addons;

            rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', data).then(function (response) {
              app.isLoading = false;
              Shopify.moveAlong();
              if (response.data.data == null) {
                app._snotifyMsg('Success', 'Your product is successfully removed.', 'Success');
                setTimeout(function () {
                  // window.location.reload();
                  app._getAddonsOrders();
                }, 2500);
              } else if (response.data.data.error) {
                app._snotifyMsg('Error', response.data.data.error, 'Error');
                return false;
              } else {
                app._snotifyMsg('Success', 'Your product is successfully removed.', 'Success');
                setTimeout(function () {
                  // window.location.reload();
                  app._getAddonsOrders();
                }, 2500);
              }
              return response;
            }).catch(function (error) {
              // console.log(error);
              if (shopify_queue.length) {
                Shopify.moveAlong();
              }
              throw error;
            });
          }
        };
        Shopify.moveAlong();
      }
    },
    _callDeleteRechargeRecurringAddons: function _callDeleteRechargeRecurringAddons(currentAddressID, cancellationValue, currentVal) {
      var addonsOrder = app.rechargeData.currentSubscription.recurringAddons;
      if (addonsOrder.length > 0) {
        var shopify_queue = [];
        addonsOrder.forEach(function (order, index) {
          app._removeAddon(event, index);
        });
      }
    },
    _activeSubscription: function _activeSubscription(event, id) {
      var config = {
        data: {
          url: "/subscriptions/" + id + "/activate",
          method: 'POST',
          data: {
            time: new Date().getTime()
          }
        }
      };

      app.isLoading = true;
      app.loadingEvent = "activate_" + id;
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        if (response.data.data.error) {
          app._snotifyMsg('Error', response.data.error, 'Error');
          return false;
        } else {
          app._getSubscriptions(app.customer.id);
          // const d = new Date();
          // const month = d.getMonth() + 1;
          // const day = d.getDate();
          // const SimplenextChargeDate = `${d.getFullYear()}-${(`${month}`).length < 2 ? '0' : ''}${month}-${(`${day}`).length < 2 ? '0' : ''}${day}`;
          // app.rechargeData.skipDateResponse.skip_next_charge_date = `${SimplenextChargeDate}T00:00:00`;
          // app._updateNextChargeDate(id);
          app.hasAnyEvent = false;
          app._closeDrawer();
          app._snotifyMsg('Success!', 'Your subscription has been successfully activated.', 'Success');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          return true;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    _snotifyMsg: function _snotifyMsg(title, msg, type) {
      if (type === 'Success') {
        app.$snotify.success(msg, title, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      } else if (type === 'Error') {
        app.$snotify.error(msg, title, {
          timeout: 3000,
          showProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          buttons: [{
            text: 'Close',
            bold: true,
            closeOnClick: true
          }]
        });
      }
    },
    _offerAdd: function _offerAdd(actionType, offerType, limit, check) {
      app.isLoading = true;
      app.loadingEvent = 'redeem_offer';
      var configNew = {};
      if (app.rechargeData.CancelReason == 'shipping_issue') {
        configNew = {
          subscription_id: app.rechargeData.currentSubscription.id,
          offer_type: offerType,
          action_type: actionType,
          no_of_times: limit,
          cust_id: app.customer.id,
          shipping_reason: app.shippingReason
        };
      } else {
        configNew = {
          subscription_id: app.rechargeData.currentSubscription.id,
          offer_type: offerType,
          action_type: actionType,
          no_of_times: limit,
          cust_id: app.customer.id,
          shipping_reason: ''
        };
      }

      // eslint-disable-next-line promise/no-nesting   
      axios.post('https://s.praella.com/doggielawn/offers', configNew)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.Error) {
          app._snotifyMsg('Error', response.data.Error, 'Error');
          return false;
        } else {
          // eslint-disable-next-line eqeqeq
          if (check == 'true') {
            app._snotifyMsg('Success!', 'You have redeemed the offer successfully.', 'Success');
          }

          app._getSubscriptions(app.customer.id);
          setTimeout(function () {
            app._closeDrawer();
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
        }
      }).catch(function (error) {
        console.log(error);
        throw error;
      });
    },
    _offerRemove: function _offerRemove() {
      var configRemove = {
        subscription_id: app.rechargeData.currentSubscription.id
      };
      // eslint-disable-next-line promise/catch-or-return
      axios.post('https://s.praella.com/doggielawn/remove_offer', configRemove)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        console.log(response);
      });
    },
    _mailSend: function _mailSend(type, date) {
      if (type === 'change') {
        // eslint-disable-next-line eqeqeq
        if (app.rechargeData.newTitle == app.rechargeData.currentSubscription.product_title) {
          // eslint-disable-next-line promise/catch-or-return
          axios.post("https://scripts.doggielawn.com/Doggielawn/change_freq_email-script.php?type=change-frequency&email=" + app.customer.email + "&name=" + app.customer.name + "&variant_title=" + app.rechargeData.selectedVariant.public_title + "&next_charge_date=" + date)
          // eslint-disable-next-line promise/always-return
          .then(function () {
            // app._closeDrawer();
            app.hasAnyEvent = true;
            //  app._getSubscriptions(app.customer.id);
          });
        } else {
          // eslint-disable-next-line promise/catch-or-return
          axios.post("https://scripts.doggielawn.com/Doggielawn/change_freq_email-script.php?type=change-size&email=" + app.customer.email + "&name=" + app.customer.name + "&product_name=" + app.rechargeData.hasProductSelected.title + "&variant_title=" + app.rechargeData.selectedVariant.public_title + "&next_charge_date=" + date)
          // eslint-disable-next-line promise/always-return
          .then(function () {
            // app._closeDrawer();
            app.hasAnyEvent = true;
            //  app._getSubscriptions(app.customer.id);
          });
        }
      } else if (type === 'skip') {
        // eslint-disable-next-line promise/catch-or-return
        axios.post("https://scripts.doggielawn.com/Doggielawn/change_freq_email-script.php?type=skip-date&email=" + app.customer.email + "&name=" + app.customer.name + "&next_charge_date=" + date)
        // eslint-disable-next-line promise/always-return
        .then(function () {
          // result
        });
      } else if (type === 'cancel') {
        app.isLoading = true;
        var cancelMailData = new FormData();
        cancelMailData.append('customer_email', app.customer.email);
        cancelMailData.append('cancel_reason', app.shippingReason);
        axios({
          method: 'post',
          url: 'https://scripts.doggielawn.com/Doggielawn/email_on_subscription_cancel.php',
          data: cancelMailData,
          headers: { 'Content-Type': 'multipart/form-data' }
        }).then(function () {
          // result
          app.shipping_mail = true;
          app.isLoading = false;
        });
      }
    },
    _mailSendForAddress: function _mailSendForAddress(address_address1, address_address2, address_company, address_city, address_country, address_zip, address_province) {
      for (var i = 0; i < address_address1.length; i++) {
        // eslint-disable-next-line eqeqeq
        if ($.trim(address_address1[i]) == '#') {
          address_address1 = address_address1.replace('#', 'HASHCODE');
        }
      }
      for (var i = 0; i < address_address2.length; i++) {
        // eslint-disable-next-line eqeqeq
        if ($.trim(address_address2[i]) == '#') {
          address_address2 = address_address2.replace('#', 'HASHCODE');
        }
      }
      // eslint-disable-next-line promise/catch-or-return
      axios.post("https://scripts.doggielawn.com/Doggielawn/change_freq_email-script.php?type=change-address&is_bill=0&email=" + app.customer.email + "&name=" + app.customer.name + "&address_address1=" + address_address1 + "&address_address2=" + address_address2 + "&address_company=" + address_company + "&address_city=" + address_city + "&address_country=" + address_country + "&address_zip=" + address_zip + "&address_province=" + address_province + "&next_charge_date=" + app.rechargeData.currentSubscription.next_charge_scheduled_at + "&c_type=" + app.rechargeData.cardDetails.payment_type + "&c_last=" + app.rechargeData.cardDetails.card_last4)
      // eslint-disable-next-line promise/always-return
      .then(function () {
        // result
      });
    },
    _mailSendForBillingAddress: function _mailSendForBillingAddress(address_address1, address_address2, address_company, address_city, address_country, address_zip, address_province) {
      for (i = 0; i < address_address1.length; i++) {
        // eslint-disable-next-line eqeqeq
        if ($.trim(address_address1[i]) == '#') {
          address_address1 = address_address1.replace('#', 'HASHCODE');
        }
      }
      for (i = 0; i < address_address2.length; i++) {
        // eslint-disable-next-line eqeqeq
        if ($.trim(address_address2[i]) == '#') {
          address_address2 = address_address2.replace('#', 'HASHCODE');
        }
      }
      // eslint-disable-next-line promise/catch-or-return
      axios.post("https://scripts.doggielawn.com/Doggielawn/change_freq_email-script.php?type=change-address&is_bill=1&email=" + app.customer.email + "&name=" + app.customer.name + "&address_address1=" + address_address1 + "&address_address2=" + address_address2 + "&address_company=" + address_company + "&address_city=" + address_city + "&address_country=" + address_country + "&address_zip=" + address_zip + "&address_province=" + address_province + "&next_charge_date=" + app.rechargeData.currentSubscription.next_charge_scheduled_at)
      // eslint-disable-next-line promise/always-return
      .then(function () {
        // result
      });
    },
    _displayDiscount: function _displayDiscount() {
      var config = {
        data: {
          url: '/charges/',
          method: 'GET',
          data: {
            address_id: app.rechargeData.currentSubscription.address_id,
            limit: 1,
            status: 'QUEUED'
          }
        }
      };
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config)
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        //  console.log(response);

        if (response.data.data.charges[0].discount_codes.length > 0) {
          app.rechargeData.currentSubscription.discount_code = response.data.data.charges[0].discount_codes[0];
        }
        // eslint-disable-next-line promise/always-return

        if (app.rechargeData.currentSubscription.discount_code != undefined) {
          $('[data-have-discount]').show().find('span').text(app.rechargeData.currentSubscription.discount_code.code + " (-$" + app.rechargeData.currentSubscription.discount_code.amount + ")");
          $('[data-nothave-discount]').hide();
        } else {
          $('[data-have-discount]').hide();
          $('[data-nothave-discount]').show();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    _applyDiscount: function _applyDiscount() {
      var code = $('[data-discount-code]').val();
      if (code == '') {
        $('[data-discount-code]').removeClass('border-gray-400').addClass('border-danger');
        return false;
      }
      var config = {
        data: {
          url: "/addresses/" + app.rechargeData.currentSubscription.address_id + "/apply_discount",
          method: 'POST',
          data: {
            discount_code: code
          }
        }
      };
      // url: `/addresses/${app.rechargeData.currentSubscription.address_id}/remove_discount`,
      // method: 'POST',
      // data: {
      //   time: new Date().getTime()
      // },
      app.isLoading = true;
      app.loadingEvent = 'apply_discount';
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {

        //  console.log(response);
        if (response.data.data.error) {
          // Rollbar.error('Something Went Wrong in Apply Discount', response.data.data.error);
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          app.hasAnyEvent = false;
          setTimeout(function () {
            app._closeDrawer();
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          return false;
        } else {
          app._getSubscriptions(app.customer.id);
          app.hasAnyEvent = false;
          app._closeDrawer();
          app._snotifyMsg('Success!', 'Your discount has been applied successfully.', 'Success');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          return true;
        }
      }).catch(function (error) {
        // Rollbar.critical('Something Went Wrong in Apply Discount', error);
        console.log(error);
      });
    },
    _toggleDiscount: function _toggleDiscount(event) {
      $(event.currentTarget).addClass('disabled');
      var delconfig = {
        data: {
          url: "/addresses/" + app.rechargeData.currentSubscription.address_id + "/remove_discount",
          method: 'POST',
          data: {
            time: new Date().getTime()
          }
        }
      };

      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', delconfig) // remove old discount
      .then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.error) {
          //  Rollbar.error('Something Went Wrong in Remove Discount', response.data.data.error);
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          setTimeout(function () {
            app._closeDrawer();
          }, 500);
          return false;
        } else {
          $('[data-change-discount]').slideToggle();
        }
      }).catch(function (error) {
        // Rollbar.critical('Something Went Wrong in Remove Discount', error);
        console.log(error);
      });
    },
    _replaceDiscount: function _replaceDiscount() {
      var code = $('[data-new-discount-code]').val();
      if (code == '') {
        $('[data-new-discount-code]').removeClass('border-gray-400').addClass('border-danger');
        return false;
      }
      var applyconfig = {
        data: {
          url: "/addresses/" + app.rechargeData.currentSubscription.address_id + "/apply_discount",
          method: 'POST',
          data: {
            discount_code: code
          }
        }
      };

      app.isLoading = true;
      app.loadingEvent = 'replace_discount';

      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', applyconfig) // apply new discount
      .then(function (response) {
        // console.log(response);
        if (response.data.data.error) {
          // Rollbar.error('Something Went Wrong in Replace Discount', response.data.data.error);
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          app.hasAnyEvent = false;
          setTimeout(function () {
            app._closeDrawer();
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          return false;
        } else {
          app._getSubscriptions(app.customer.id);
          app.hasAnyEvent = false;
          app._closeDrawer();
          app._snotifyMsg('Success!', 'Your new discount has been applied successfully.', 'Success');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
          }, 500);
          return true;
        }
      }).catch(function (error) {
        //  Rollbar.critical('Something Went Wrong in Remove Discount', error);
        console.log(error);
      });
    },
    _getAddons: function _getAddons() {
      var Addons = app.rechargeData.subscriptionsList.filter(function (ele, i) {
        return ele.address_id == app.rechargeData.currentSubscription.address_id && ele.isAddon == true;
      });
      $(Addons).each(function (i, add) {
        // get image
        var img = add.properties.filter(function (prop) {
          return prop.name == 'product-image';
        });
        if (img.length) {
          add.product_image = img[0].value;
        }
      });
      app.rechargeData.currentSubscription.recurringAddons = Addons;
      if (app.rechargeData.currentSubscription.recurringAddons.length > 0) {
        setTimeout(function () {
          $('[data-manage-addons]').removeClass('d-none').addClass('d-flex');
          $('[data-sub-options]').addClass('p-1');
        }, 50);
      } else {
        $('[data-manage-addons]').addClass('d-none').removeClass('d-flex');
        $('[data-sub-options]').removeClass('p-1');
      }
    },
    _removeAddon: function _removeAddon(event, index) {
      app.isLoading = true;
      app.loadingEvent = 'removing_addon_' + app.rechargeData.currentSubscription.recurringAddons[index].id;
      var delsubFormData = new FormData();
      delsubFormData.append('subscription_id', app.rechargeData.currentSubscription.recurringAddons[index].id);
      axios({
        method: 'post',
        url: 'https://scripts.doggielawn.com/Doggielawn/delete_addone_subscription.php',
        data: delsubFormData,
        headers: { 'Content-Type': 'multipart/form-data' }
      })
      // eslint-disable-next-line promise/always-return
      .then(function (response) {
        // handle success
        setTimeout(function () {
          app.isLoading = false;
          app.loadingEvent = null;
          app.hasAnyEvent = true;
          app._getSubscriptions(app.customer.id);
        }, 500);
      }).catch(function (response) {
        // handle error
        app.isLoading = false;
        app.loadingEvent = null;
      });
    },
    _ChangeFreqAddon: function _ChangeFreqAddon(event, index) {
      app.changeFreqAddon = true;
      app.rechargeData.currentSubscription.currentAddon = app.rechargeData.currentSubscription.recurringAddons[index];
    },
    _getFrequency: function _getFrequency(event) {
      var $target = $(event.target);
      if ($target.val() != '' && $target.val() != app.rechargeData.currentSubscription.currentAddon.order_interval_frequency) {
        app.newAddonFreq = true;
        app.rechargeData.currentSubscription.currentAddon.newFrequency = $target.val();
      } else {
        app.newAddonFreq = false;
      }
    },
    _updateAddonFreq: function _updateAddonFreq(event) {
      var $target = $(event.currentTarget);
      app.isLoading = true;
      app.loadingEvent = 'change_freq_addon';
      var Addon = app.rechargeData.currentSubscription.currentAddon;
      var prop = Addon.properties;
      var AddonPropExists = Addon.properties.filter(function (ele) {
        return ele.name == 'UpdateAddonFreq';
      });
      if (Addon.newFrequency != app.rechargeData.currentSubscription.order_interval_frequency) {
        // if new freq selected
        if (AddonPropExists.length == 0) {
          // if prop does not exists
          prop.push({ name: 'UpdateAddonFreq', value: true });
        }
      } else {
        // if same freq selected
        if (AddonPropExists.length > 0) {
          // if prop already exists
          prop = Addon.properties.filter(function (ele) {
            return ele.name != 'UpdateAddonFreq';
          });
        }
      }

      var config = {
        data: {
          url: "/subscriptions/" + Addon.id,
          method: 'PUT',
          data: {
            shopify_product_id: Addon.shopify_product_id,
            price: Addon.price,
            shopify_variant_id: Addon.shopify_variant_id,
            product_title: Addon.product_title,
            order_interval_unit: Addon.order_interval_unit,
            order_interval_frequency: Addon.newFrequency,
            charge_interval_frequency: Addon.newFrequency,
            properties: prop
          }
        }
      };

      // eslint-disable-next-line promise/catch-or-return
      rechargeCommonAPI.post('https://scripts.doggielawn.com/recharge/doggielawn/api/common', config).then(function (response) {
        // eslint-disable-next-line promise/always-return
        if (response.data.data.error) {
          app._snotifyMsg('Error', response.data.data.error, 'Error');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app._getSubscriptions(app.customer.id);
            app._closeDrawer();
          }, 300);
          return false;
        } else if (response.data.data.warning === 'too many requests') {
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app._getSubscriptions(app.customer.id);
            app._closeDrawer();
          }, 300);
        } else if (response.data.data.errors) {
          app._snotifyMsg('Error', response.data.data.errors, 'Error');
          return false;
        } else {
          app._snotifyMsg('Success!', 'The Add-on frequency has been changed successfully', 'Success');
          setTimeout(function () {
            app.isLoading = false;
            app.loadingEvent = null;
            app.hasAnyEvent = true;
            app._getSubscriptions(app.customer.id);
          }, 300);
          return true;
        }
      });
    },
    check_shipping: function check_shipping(event) {
      var $this = $(event.target);
      if ($this.val() == 'something_else') {
        $('[shipping_experienced]').removeClass('d-none');
      } else {
        $('[shipping_experienced]').addClass('d-none');
      }
    }
  }
};

export default rechargeMethods;